
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("fBqzD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::df4fc88f40749d293570c808b4b489c6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b5beecb0f151b357$var$_react = $b5beecb0f151b357$var$_interopRequireDefault((parcelRequire("cozmU")));

var $b5beecb0f151b357$var$_baseNew = $b5beecb0f151b357$var$_interopRequireDefault((parcelRequire("gElAV")));
function $b5beecb0f151b357$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PeopleGroup".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/people-group
 * Usage guidance:
 * Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b5beecb0f151b357$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $b5beecb0f151b357$var$_react.default.createElement($b5beecb0f151b357$var$_baseNew.default, Object.assign({
        name: "PeopleGroupIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9 4.5a2 2 0 1 1 4 0 2 2 0 0 1-4 0M11 1a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7M3 5.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0M4 3a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M2.625 9A2.625 2.625 0 0 0 0 11.625V13h1.5v-1.375c0-.621.504-1.125 1.125-1.125H5V9zM6 12.5A3.5 3.5 0 0 1 9.5 9h3a3.5 3.5 0 0 1 3.5 3.5V14h-1.5v-1.5a2 2 0 0 0-2-2h-3a2 2 0 0 0-2 2V14H6z" clip-rule="evenodd"/>`
    }, props));
$b5beecb0f151b357$var$PeopleGroupIcon.displayName = 'PeopleGroupIcon';
var $b5beecb0f151b357$var$_default = module.exports.default = $b5beecb0f151b357$var$PeopleGroupIcon;

});

parcelRegister("gElAV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("QJ7O4")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("QJ7O4")).Icon);
/**
 * @deprecated Import from the generated per-export subpath instead.
 */ 
var $QJ7O4 = parcelRequire("QJ7O4");


});

parcelRegister("QJ7O4", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $dbeb649a40d0d17b$var$svgStyles = null;
const $dbeb649a40d0d17b$var$iconStyles = null;
const $dbeb649a40d0d17b$var$smallIconStyles = null;
const $dbeb649a40d0d17b$var$scaleStyles = null; /**
                           * For windows high contrast mode
                           */ 
const $dbeb649a40d0d17b$var$baseHcmStyles = null;
const $dbeb649a40d0d17b$var$scaleSize = null;
const $dbeb649a40d0d17b$var$coreSizeMedium = {
    none: "_39xV025zaO _0jFU0V5zaO",
    compact: "_39xV02NHnM _0jFU0VNHnM",
    spacious: "_39xV02NHnM _0jFU0VNHnM"
};
const $dbeb649a40d0d17b$var$coreSizeSmall = {
    none: "_39xV028HPE _0jFU0V8HPE",
    compact: "_39xV025zaO _0jFU0V5zaO",
    spacious: "_39xV02NHnM _0jFU0VNHnM"
};
const $dbeb649a40d0d17b$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
}; /**
              * __Icon__
              *
              * An icon is used as a visual representation of common actions and commands to provide context.
              *
              * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
              */ 
const $dbeb649a40d0d17b$export$f04a61298a47a40f = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? function Icon(props) {
    const $ = (0, $bDgLe.c)(24);
    const { color: t0, testId: testId, label: label, dangerouslySetGlyph: dangerouslySetGlyph, shouldScale: shouldScale, spacing: t1, name: name } = props;
    const color = t0 === undefined ? "currentColor" : t0;
    const spacing = t1 === undefined ? "none" : t1;
    let t2;
    if ($[0] !== dangerouslySetGlyph) {
        t2 = dangerouslySetGlyph ? {
            __html: dangerouslySetGlyph
        } : undefined;
        $[0] = dangerouslySetGlyph;
        $[1] = t2;
    } else t2 = $[1];
    const dangerouslySetInnerHTML = t2;
    let size = "medium";
    if ("size" in props && props.size !== undefined) {
        if (typeof props.size === "string") size = props.size === "small" || props.size === "medium" ? props.size : "medium";
        else if (name) {
            let t3;
            if ($[2] !== name || $[3] !== props.size) {
                t3 = props.size(name);
                $[2] = name;
                $[3] = props.size;
                $[4] = t3;
            } else t3 = $[4];
            const newSize = t3;
            size = newSize === "small" || newSize === "medium" ? newSize : "medium";
        }
    }
    const viewBoxPadding = $dbeb649a40d0d17b$var$paddingMap[size][spacing];
    const viewBoxSize = 16 + 2 * viewBoxPadding;
    const t3 = label ? "img" : undefined;
    const t4 = label ? label : undefined;
    const t5 = label ? undefined : true;
    let t6;
    if ($[5] !== color) {
        t6 = {
            color: color
        };
        $[5] = color;
        $[6] = t6;
    } else t6 = $[6];
    const t7 = shouldScale && "_39xV02OLYo _0jFU0VOLYo";
    const t8 = size === "small" && "_26BoRw8HPE";
    let t9;
    if ($[7] !== t7 || $[8] !== t8) {
        t9 = (0, $hekY6.default)([
            "_3iDTPbvbI6 _24h04i2Njc _3YEZNOdnbC _26BoRw7dHp _03SyCPU7Rg _0LQT5ECyim",
            "_2z3AMPTxK4 _1hdADdMFyn",
            t7,
            t8
        ]);
        $[7] = t7;
        $[8] = t8;
        $[9] = t9;
    } else t9 = $[9];
    const t10 = `${0 - viewBoxPadding} ${0 - viewBoxPadding} ${viewBoxSize} ${viewBoxSize}`;
    const t11 = shouldScale ? "_39xV02OLYo _0jFU0VOLYo" : size === "small" ? $dbeb649a40d0d17b$var$coreSizeSmall[spacing] : $dbeb649a40d0d17b$var$coreSizeMedium[spacing];
    let t12;
    if ($[10] !== t11) {
        t12 = (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _1UtDYz98eZ _1pp6NdYbGa _1RrJLiUWqv _24fbFs98eZ",
            t11
        ]);
        $[10] = t11;
        $[11] = t12;
    } else t12 = $[11];
    let t13;
    if ($[12] !== dangerouslySetInnerHTML || $[13] !== t10 || $[14] !== t12) {
        t13 = /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
            fill: "none",
            viewBox: t10,
            role: "presentation",
            dangerouslySetInnerHTML: dangerouslySetInnerHTML,
            className: t12
        });
        $[12] = dangerouslySetInnerHTML;
        $[13] = t10;
        $[14] = t12;
        $[15] = t13;
    } else t13 = $[15];
    let t14;
    if ($[16] !== t13 || $[17] !== t3 || $[18] !== t4 || $[19] !== t5 || $[20] !== t6 || $[21] !== t9 || $[22] !== testId) {
        t14 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            "data-testid": testId,
            role: t3,
            "aria-label": t4,
            "aria-hidden": t5,
            style: t6,
            className: t9,
            children: t13
        });
        $[16] = t13;
        $[17] = t3;
        $[18] = t4;
        $[19] = t5;
        $[20] = t6;
        $[21] = t9;
        $[22] = testId;
        $[23] = t14;
    } else t14 = $[23];
    return t14;
} : function Icon(props) {
    const { color: color = 'currentColor', testId: testId, label: label, dangerouslySetGlyph: // Used to set icon dimensions/behaviour in codegen
    // Used to set icon glyphs in codegen
    dangerouslySetGlyph, shouldScale: // Used with iconTile to scale icon up and down
    shouldScale, spacing: spacing = 'none', name: name } = props;
    const dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    let size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            const newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    const baseSize = 16;
    const viewBoxPadding = $dbeb649a40d0d17b$var$paddingMap[size][spacing];
    const viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $hekY6.default)([
            "_3iDTPbvbI6 _24h04i2Njc _3YEZNOdnbC _26BoRw7dHp _03SyCPU7Rg _0LQT5ECyim",
            "_2z3AMPTxK4 _1hdADdMFyn",
            shouldScale && "_39xV02OLYo _0jFU0VOLYo",
            size === 'small' && "_26BoRw8HPE"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
            fill: "none",
            // we want for Icon Tile
            viewBox: `${0 - viewBoxPadding} ${0 - viewBoxPadding} ${viewBoxSize} ${viewBoxSize}`,
            role: "presentation",
            dangerouslySetInnerHTML: dangerouslySetInnerHTML,
            className: (0, $hekY6.default)([
                "_4bt5LAnQyn _2WAcuGnQyn _1UtDYz98eZ _1pp6NdYbGa _1RrJLiUWqv _24fbFs98eZ",
                shouldScale ? "_39xV02OLYo _0jFU0VOLYo" : size === 'small' ? $dbeb649a40d0d17b$var$coreSizeSmall[spacing] : $dbeb649a40d0d17b$var$coreSizeMedium[spacing]
            ])
        })
    });
}); // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $dbeb649a40d0d17b$export$2e2bcd8739ae039 = $dbeb649a40d0d17b$export$f04a61298a47a40f;
module.exports["Icon"] = $dbeb649a40d0d17b$export$f04a61298a47a40f;
module.exports["default"] = $dbeb649a40d0d17b$export$2e2bcd8739ae039;

});

parcelRegister("kkFbH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::49fc2abb731b0d5d523db8193eb7128c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ecd59ff2a8282f4d$var$_react = $ecd59ff2a8282f4d$var$_interopRequireDefault((parcelRequire("cozmU")));

var $ecd59ff2a8282f4d$var$_baseNew = $ecd59ff2a8282f4d$var$_interopRequireDefault((parcelRequire("gElAV")));
function $ecd59ff2a8282f4d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "File".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/file
 * Usage guidance:
 * Multi purpose - Known uses: document, file. Do not use to represent a page — use the dedicated 'Page' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ecd59ff2a8282f4d$var$FileIcon = (props)=>/*#__PURE__*/ $ecd59ff2a8282f4d$var$_react.default.createElement($ecd59ff2a8282f4d$var$_baseNew.default, Object.assign({
        name: "FileIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5.25c0-.52-.206-1.017-.573-1.384L10.134.573A1.96 1.96 0 0 0 8.75 0H4a2 2 0 0 0-2 2zm2 .5a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h4v3.75c0 .414.336.75.75.75h3.75v8a.5.5 0 0 1-.5.5zm7.94-10H9.5V2.06z" clip-rule="evenodd"/>`
    }, props));
$ecd59ff2a8282f4d$var$FileIcon.displayName = 'FileIcon';
var $ecd59ff2a8282f4d$var$_default = module.exports.default = $ecd59ff2a8282f4d$var$FileIcon;

});

parcelRegister("gxI48", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8e52e234cd3835d6e7bf18cc8a602b76>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c0b1e8f695e7c881$var$_react = $c0b1e8f695e7c881$var$_interopRequireDefault((parcelRequire("cozmU")));

var $c0b1e8f695e7c881$var$_baseNew = $c0b1e8f695e7c881$var$_interopRequireDefault((parcelRequire("gElAV")));
function $c0b1e8f695e7c881$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Attachment".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/attachment
 * Usage guidance:
 * Reserved for attaching files to work types or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c0b1e8f695e7c881$var$AttachmentIcon = (props)=>/*#__PURE__*/ $c0b1e8f695e7c881$var$_react.default.createElement($c0b1e8f695e7c881$var$_baseNew.default, Object.assign({
        name: "AttachmentIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m5.22 8.47 4.5-4.5 1.06 1.06-4.5 4.5a.664.664 0 0 0 .94.94l4.5-4.5a2.079 2.079 0 0 0-2.94-2.94l-4.5 4.5a3.492 3.492 0 0 0 4.94 4.94l2.5-2.5 1.06 1.06-2.5 2.5a4.993 4.993 0 0 1-7.06-7.06l4.5-4.5a3.578 3.578 0 0 1 5.06 5.06l-4.5 4.5a2.165 2.165 0 0 1-3.06-3.06"/>`
    }, props));
$c0b1e8f695e7c881$var$AttachmentIcon.displayName = 'AttachmentIcon';
var $c0b1e8f695e7c881$var$_default = module.exports.default = $c0b1e8f695e7c881$var$AttachmentIcon;

});

parcelRegister("iAaYd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8d68b0ed6443e7362a97c249dd57005c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d87419384e6bf73a$var$_react = $d87419384e6bf73a$var$_interopRequireDefault((parcelRequire("cozmU")));

var $d87419384e6bf73a$var$_baseNew = $d87419384e6bf73a$var$_interopRequireDefault((parcelRequire("gElAV")));
function $d87419384e6bf73a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Task".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/task
 * Usage guidance:
 * Single purpose - Reserved for tasks in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d87419384e6bf73a$var$TaskIcon = (props)=>/*#__PURE__*/ $d87419384e6bf73a$var$_react.default.createElement($d87419384e6bf73a$var$_baseNew.default, Object.assign({
        name: "TaskIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm9.326 2.98-5 6a.75.75 0 0 1-1.152 0l-2.5-3 1.152-.96L6.75 9.828l4.424-5.308z" clip-rule="evenodd"/>`
    }, props));
$d87419384e6bf73a$var$TaskIcon.displayName = 'TaskIcon';
var $d87419384e6bf73a$var$_default = module.exports.default = $d87419384e6bf73a$var$TaskIcon;

});

parcelRegister("a79Sy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e03a1abef9c7552042b0641d7d345b1c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $75d23894928204ad$var$_react = $75d23894928204ad$var$_interopRequireDefault((parcelRequire("cozmU")));

var $75d23894928204ad$var$_baseNew = $75d23894928204ad$var$_interopRequireDefault((parcelRequire("gElAV")));
function $75d23894928204ad$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EyeOpen".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/eye-open
 * Usage guidance:
 * Multi purpose - Known uses: watch page in Confluence, show password in text field, and following in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $75d23894928204ad$var$EyeOpenIcon = (props)=>/*#__PURE__*/ $75d23894928204ad$var$_react.default.createElement($75d23894928204ad$var$_baseNew.default, Object.assign({
        name: "EyeOpenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3.5c-2.943 0-5.49 1.845-6.424 4.396a.3.3 0 0 0 0 .208C2.509 10.655 5.057 12.5 8 12.5s5.49-1.845 6.424-4.396a.3.3 0 0 0 0-.208C13.491 5.345 10.943 3.5 8 3.5M.167 7.38C1.32 4.232 4.433 2 8 2c3.566 0 6.681 2.232 7.833 5.38.146.4.146.84 0 1.24C14.68 11.768 11.566 14 8 14 4.433 14 1.319 11.768.167 8.62a1.8 1.8 0 0 1 0-1.24M8 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$75d23894928204ad$var$EyeOpenIcon.displayName = 'EyeOpenIcon';
var $75d23894928204ad$var$_default = module.exports.default = $75d23894928204ad$var$EyeOpenIcon;

});

parcelRegister("11OF7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e14a292f801fb6f142cba86986a6f69b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0bfd2ee817f14aef$var$_react = $0bfd2ee817f14aef$var$_interopRequireDefault((parcelRequire("cozmU")));

var $0bfd2ee817f14aef$var$_baseNew = $0bfd2ee817f14aef$var$_interopRequireDefault((parcelRequire("gElAV")));
function $0bfd2ee817f14aef$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Settings".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/settings
 * Usage guidance:
 * Single purpose - Reserved for any object or user settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0bfd2ee817f14aef$var$SettingsIcon = (props)=>/*#__PURE__*/ $0bfd2ee817f14aef$var$_react.default.createElement($0bfd2ee817f14aef$var$_baseNew.default, Object.assign({
        name: "SettingsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.058.462A.75.75 0 0 1 6.75 0h2.5a.75.75 0 0 1 .692.462l1.026 2.462 2.578-.374a.75.75 0 0 1 .757.367l1.25 2.166a.75.75 0 0 1-.049.824L13.937 8l1.567 2.093c.18.24.2.565.05.825l-1.25 2.165a.75.75 0 0 1-.758.367l-2.578-.374-1.026 2.463A.75.75 0 0 1 9.25 16h-2.5a.75.75 0 0 1-.692-.461l-1.026-2.463-2.578.374a.75.75 0 0 1-.757-.367l-1.25-2.165a.75.75 0 0 1 .049-.825L2.063 8 .496 5.907a.75.75 0 0 1-.05-.824l1.25-2.166a.75.75 0 0 1 .758-.367l2.578.374zM7.25 1.5l-.871 2.09c-.242.58-.845.923-1.467.833l-2.17-.315-.749 1.296L3.32 7.176c.366.488.366 1.16 0 1.648l-1.327 1.772.749 1.296 2.17-.315a1.375 1.375 0 0 1 1.467.832L7.25 14.5h1.5l.871-2.09c.242-.58.845-.923 1.467-.833l2.17.315.749-1.296-1.327-1.772a1.375 1.375 0 0 1 0-1.648l1.327-1.772-.749-1.296-2.17.315A1.375 1.375 0 0 1 9.62 3.59L8.75 1.5zm.75 5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$0bfd2ee817f14aef$var$SettingsIcon.displayName = 'SettingsIcon';
var $0bfd2ee817f14aef$var$_default = module.exports.default = $0bfd2ee817f14aef$var$SettingsIcon;

});

parcelRegister("hAgam", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8bb19b6f8ad9918a0227c958ed777f68>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ccd256b8447fd064$var$_react = $ccd256b8447fd064$var$_interopRequireDefault((parcelRequire("cozmU")));

var $ccd256b8447fd064$var$_baseNew = $ccd256b8447fd064$var$_interopRequireDefault((parcelRequire("gElAV")));
function $ccd256b8447fd064$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Search".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/search
 * Usage guidance:
 * Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ccd256b8447fd064$var$SearchIcon = (props)=>/*#__PURE__*/ $ccd256b8447fd064$var$_react.default.createElement($ccd256b8447fd064$var$_baseNew.default, Object.assign({
        name: "SearchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7 2.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9M1 7a6 6 0 1 1 10.74 3.68l3.29 3.29-1.06 1.06-3.29-3.29A6 6 0 0 1 1 7" clip-rule="evenodd"/>`
    }, props));
$ccd256b8447fd064$var$SearchIcon.displayName = 'SearchIcon';
var $ccd256b8447fd064$var$_default = module.exports.default = $ccd256b8447fd064$var$SearchIcon;

});

parcelRegister("hMaHH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::941e8d0be0ace481eafee9558e4b964e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cf0f38f208b624b3$var$_react = $cf0f38f208b624b3$var$_interopRequireDefault((parcelRequire("cozmU")));

var $cf0f38f208b624b3$var$_baseNew = $cf0f38f208b624b3$var$_interopRequireDefault((parcelRequire("gElAV")));
function $cf0f38f208b624b3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Page".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/page
 * Usage guidance:
 * Single purpose - Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cf0f38f208b624b3$var$PageIcon = (props)=>/*#__PURE__*/ $cf0f38f208b624b3$var$_react.default.createElement($cf0f38f208b624b3$var$_baseNew.default, Object.assign({
        name: "PageIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM12 6H4V4.5h8zm-2 3.5H4V8h6z" clip-rule="evenodd"/>`
    }, props));
$cf0f38f208b624b3$var$PageIcon.displayName = 'PageIcon';
var $cf0f38f208b624b3$var$_default = module.exports.default = $cf0f38f208b624b3$var$PageIcon;

});

parcelRegister("hMcNB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6e352727a1bd9b30abdccc90ca5ed341>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cf10d8f674e6922d$var$_react = $cf10d8f674e6922d$var$_interopRequireDefault((parcelRequire("cozmU")));

var $cf10d8f674e6922d$var$_baseNew = $cf10d8f674e6922d$var$_interopRequireDefault((parcelRequire("gElAV")));
function $cf10d8f674e6922d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Automation".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/automation
 * Usage guidance:
 * Single purpose - Reserved to represent an Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cf10d8f674e6922d$var$AutomationIcon = (props)=>/*#__PURE__*/ $cf10d8f674e6922d$var$_react.default.createElement($cf10d8f674e6922d$var$_baseNew.default, Object.assign({
        name: "AutomationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.377.102a.75.75 0 0 1 .346.847L8.985 7.25h4.265a.75.75 0 0 1 .53 1.28l-7.25 7.25a.75.75 0 0 1-1.253-.73l1.738-6.3H2.75a.75.75 0 0 1-.53-1.28L9.47.22a.75.75 0 0 1 .907-.118M7.43 7.25l1.093-3.96L4.56 7.25zm1.142 1.5-1.093 3.96 3.961-3.96z" clip-rule="evenodd"/>`
    }, props));
$cf10d8f674e6922d$var$AutomationIcon.displayName = 'AutomationIcon';
var $cf10d8f674e6922d$var$_default = module.exports.default = $cf10d8f674e6922d$var$AutomationIcon;

});

parcelRegister("p6OqS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4280f7551e499f7a2c035b7754e375c0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $04b79eb870b0d716$var$_react = $04b79eb870b0d716$var$_interopRequireDefault((parcelRequire("cozmU")));

var $04b79eb870b0d716$var$_baseNew = $04b79eb870b0d716$var$_interopRequireDefault((parcelRequire("gElAV")));
function $04b79eb870b0d716$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Briefcase".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/briefcase
 * Usage guidance:
 * Multi purpose - Known uses: Job title in Atlas, Operations in JSM.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $04b79eb870b0d716$var$BriefcaseIcon = (props)=>/*#__PURE__*/ $04b79eb870b0d716$var$_react.default.createElement($04b79eb870b0d716$var$_baseNew.default, Object.assign({
        name: "BriefcaseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14 10.555A13.4 13.4 0 0 1 8 12a13.4 13.4 0 0 1-6-1.445V13a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5zM14 6a.5.5 0 0 0-.5-.5h-11A.5.5 0 0 0 2 6v2.84q.056.036.121.075A11.9 11.9 0 0 0 8 10.5a11.9 11.9 0 0 0 5.879-1.585L14 8.84zm-4-3a.5.5 0 0 0-.5-.5h-3A.5.5 0 0 0 6 3v1h4zm1.5 1h2a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2h-11a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2V3a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2z"/><path fill="currentcolor" d="M8 8a.75.75 0 1 1 0 1.5A.75.75 0 0 1 8 8"/>`
    }, props));
$04b79eb870b0d716$var$BriefcaseIcon.displayName = 'BriefcaseIcon';
var $04b79eb870b0d716$var$_default = module.exports.default = $04b79eb870b0d716$var$BriefcaseIcon;

});

parcelRegister("kpuvJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6a236ae450a0df0bf2faf6207167ff43>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $edbdcf44d46ac735$var$_react = $edbdcf44d46ac735$var$_interopRequireDefault((parcelRequire("cozmU")));

var $edbdcf44d46ac735$var$_baseNew = $edbdcf44d46ac735$var$_interopRequireDefault((parcelRequire("gElAV")));
function $edbdcf44d46ac735$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "OfficeBuilding".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/office-building
 * Usage guidance:
 * Multi purpose - Known uses: office in Atlas, company.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $edbdcf44d46ac735$var$OfficeBuildingIcon = (props)=>/*#__PURE__*/ $edbdcf44d46ac735$var$_react.default.createElement($edbdcf44d46ac735$var$_baseNew.default, Object.assign({
        name: "OfficeBuildingIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12.5h1V16H1v-1.5h1zm1.5 12.5h2v-3.75a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 .75.75v3.75h2V2a.5.5 0 0 0-.5-.5H4a.5.5 0 0 0-.5.5zm5.5 0v-3H7v3zm-2-10H5V3h2zm4 0H9V3h2zM5 6h2v1.5H5zm4 0h2v1.5H9z" clip-rule="evenodd"/>`
    }, props));
$edbdcf44d46ac735$var$OfficeBuildingIcon.displayName = 'OfficeBuildingIcon';
var $edbdcf44d46ac735$var$_default = module.exports.default = $edbdcf44d46ac735$var$OfficeBuildingIcon;

});

parcelRegister("g9ioO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::78e29a42ae04e7de3faf9cb14ac698bd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bc1bc2509a60e4c8$var$_react = $bc1bc2509a60e4c8$var$_interopRequireDefault((parcelRequire("cozmU")));

var $bc1bc2509a60e4c8$var$_baseNew = $bc1bc2509a60e4c8$var$_interopRequireDefault((parcelRequire("gElAV")));
function $bc1bc2509a60e4c8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Person".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/person
 * Usage guidance:
 * Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bc1bc2509a60e4c8$var$PersonIcon = (props)=>/*#__PURE__*/ $bc1bc2509a60e4c8$var$_react.default.createElement($bc1bc2509a60e4c8$var$_baseNew.default, Object.assign({
        name: "PersonIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m-2 9a3.75 3.75 0 0 1 3.75-3.75h4.5A3.75 3.75 0 0 1 14 13v2h-1.5v-2a2.25 2.25 0 0 0-2.25-2.25h-4.5A2.25 2.25 0 0 0 3.5 13v2H2z" clip-rule="evenodd"/>`
    }, props));
$bc1bc2509a60e4c8$var$PersonIcon.displayName = 'PersonIcon';
var $bc1bc2509a60e4c8$var$_default = module.exports.default = $bc1bc2509a60e4c8$var$PersonIcon;

});

parcelRegister("6Cex3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c322cb443b1343016361f8579459466e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4d11907671106272$var$_react = $4d11907671106272$var$_interopRequireDefault((parcelRequire("cozmU")));

var $4d11907671106272$var$_baseNew = $4d11907671106272$var$_interopRequireDefault((parcelRequire("gElAV")));
function $4d11907671106272$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StarStarred".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/star-starred
 * Usage guidance:
 * Single purpose - Reserved for starred or favourited objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4d11907671106272$var$StarStarredIcon = (props)=>/*#__PURE__*/ $4d11907671106272$var$_react.default.createElement($4d11907671106272$var$_baseNew.default, Object.assign({
        name: "StarStarredIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a.75.75 0 0 1 .7.48l1.705 4.434 4.403.338a.75.75 0 0 1 .422 1.324l-3.38 2.818 1.25 4.662a.75.75 0 0 1-1.148.813L8 12.159l-3.95 2.71a.75.75 0 0 1-1.15-.813l1.251-4.662L.77 6.576a.75.75 0 0 1 .422-1.324l4.403-.338L7.3.48A.75.75 0 0 1 8 0m0 2.84L6.655 6.335l-3.506.27 2.7 2.25-.973 3.627L8 10.341l3.124 2.142-.973-3.627 2.7-2.25-3.506-.27z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.655 6.336 8 2.84l1.345 3.497 3.506.27-2.7 2.25.973 3.627L8 10.341l-3.124 2.142.973-3.627-2.7-2.25z"/>`
    }, props));
$4d11907671106272$var$StarStarredIcon.displayName = 'StarStarredIcon';
var $4d11907671106272$var$_default = module.exports.default = $4d11907671106272$var$StarStarredIcon;

});

parcelRegister("bH62g", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a5f94a889eb4be2847f401c5ce87b273>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $88386460b33fc74a$var$_react = $88386460b33fc74a$var$_interopRequireDefault((parcelRequire("cozmU")));

var $88386460b33fc74a$var$_baseNew = $88386460b33fc74a$var$_interopRequireDefault((parcelRequire("gElAV")));
function $88386460b33fc74a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignTextCenter".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/align-text-center
 * Usage guidance:
 * Multi purpose - Known uses: align text center, align center.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $88386460b33fc74a$var$AlignTextCenterIcon = (props)=>/*#__PURE__*/ $88386460b33fc74a$var$_react.default.createElement($88386460b33fc74a$var$_baseNew.default, Object.assign({
        name: "AlignTextCenterIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12 3.5H4V2h8zm3 5.25H1v-1.5h14zM12 14H4v-1.5h8z" clip-rule="evenodd"/>`
    }, props));
$88386460b33fc74a$var$AlignTextCenterIcon.displayName = 'AlignTextCenterIcon';
var $88386460b33fc74a$var$_default = module.exports.default = $88386460b33fc74a$var$AlignTextCenterIcon;

});

parcelRegister("2PKI8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0bcb375952b1620c2176903c7d0cab3d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $210494048b554c16$var$_react = $210494048b554c16$var$_interopRequireDefault((parcelRequire("cozmU")));

var $210494048b554c16$var$_baseNew = $210494048b554c16$var$_interopRequireDefault((parcelRequire("gElAV")));
function $210494048b554c16$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignTextRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/align-text-right
 * Usage guidance:
 * Multi purpose - Known uses: align text right, align content right.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $210494048b554c16$var$AlignTextRightIcon = (props)=>/*#__PURE__*/ $210494048b554c16$var$_react.default.createElement($210494048b554c16$var$_baseNew.default, Object.assign({
        name: "AlignTextRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm0 5.25H1v-1.5h14zM15 14H8v-1.5h7z" clip-rule="evenodd"/>`
    }, props));
$210494048b554c16$var$AlignTextRightIcon.displayName = 'AlignTextRightIcon';
var $210494048b554c16$var$_default = module.exports.default = $210494048b554c16$var$AlignTextRightIcon;

});

parcelRegister("kdlgT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3459fd94acce85771d87d968e2cc17a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eb75859b11c51c7f$var$_react = $eb75859b11c51c7f$var$_interopRequireDefault((parcelRequire("cozmU")));

var $eb75859b11c51c7f$var$_baseNew = $eb75859b11c51c7f$var$_interopRequireDefault((parcelRequire("gElAV")));
function $eb75859b11c51c7f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/arrow-left
 * Usage guidance:
 * Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eb75859b11c51c7f$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $eb75859b11c51c7f$var$_react.default.createElement($eb75859b11c51c7f$var$_baseNew.default, Object.assign({
        name: "ArrowLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m1.22 7.47 5-5 1.06 1.06-3.72 3.72H15v1.5H3.56l3.72 3.72-1.06 1.06-5-5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$eb75859b11c51c7f$var$ArrowLeftIcon.displayName = 'ArrowLeftIcon';
var $eb75859b11c51c7f$var$_default = module.exports.default = $eb75859b11c51c7f$var$ArrowLeftIcon;

});

parcelRegister("aRvnq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::399f3a5d75450ad8ec544b3cd80ab701>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7e873168dcf9438d$var$_react = $7e873168dcf9438d$var$_interopRequireDefault((parcelRequire("cozmU")));

var $7e873168dcf9438d$var$_baseNew = $7e873168dcf9438d$var$_interopRequireDefault((parcelRequire("gElAV")));
function $7e873168dcf9438d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/arrow-right
 * Usage guidance:
 * Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7e873168dcf9438d$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $7e873168dcf9438d$var$_react.default.createElement($7e873168dcf9438d$var$_baseNew.default, Object.assign({
        name: "ArrowRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.44 7.25 8.72 3.53l1.06-1.06 5 5a.75.75 0 0 1 0 1.06l-5 5-1.06-1.06 3.72-3.72H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$7e873168dcf9438d$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $7e873168dcf9438d$var$_default = module.exports.default = $7e873168dcf9438d$var$ArrowRightIcon;

});

parcelRegister("XgBmC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8597222b6b414a4b1fc500f20a14a6bf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0b22638b07af3f6a$var$_react = $0b22638b07af3f6a$var$_interopRequireDefault((parcelRequire("cozmU")));

var $0b22638b07af3f6a$var$_baseNew = $0b22638b07af3f6a$var$_interopRequireDefault((parcelRequire("gElAV")));
function $0b22638b07af3f6a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EyeOpenFilled".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/eye-open-filled
 * Usage guidance:
 * Multi purpose - Known uses: watched pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0b22638b07af3f6a$var$EyeOpenFilledIcon = (props)=>/*#__PURE__*/ $0b22638b07af3f6a$var$_react.default.createElement($0b22638b07af3f6a$var$_baseNew.default, Object.assign({
        name: "EyeOpenFilledIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.75 8a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0"/><path fill="currentcolor" fill-rule="evenodd" d="M8 2C4.433 2 1.319 4.232.167 7.38c-.146.4-.146.84 0 1.24C1.32 11.768 4.433 14 8 14c3.566 0 6.681-2.232 7.833-5.38.146-.4.146-.84 0-1.24C14.68 4.232 11.566 2 8 2m0 2.25a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5" clip-rule="evenodd"/>`
    }, props));
$0b22638b07af3f6a$var$EyeOpenFilledIcon.displayName = 'EyeOpenFilledIcon';
var $0b22638b07af3f6a$var$_default = module.exports.default = $0b22638b07af3f6a$var$EyeOpenFilledIcon;

});

parcelRegister("gIfnJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d0fdfdae0d4d1dbd52f0a0a21794255a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c2acafe292c67b9a$var$_react = $c2acafe292c67b9a$var$_interopRequireDefault((parcelRequire("cozmU")));

var $c2acafe292c67b9a$var$_baseNew = $c2acafe292c67b9a$var$_interopRequireDefault((parcelRequire("gElAV")));
function $c2acafe292c67b9a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Branch".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/branch
 * Usage guidance:
 * Single purpose - Reserved for branches in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c2acafe292c67b9a$var$BranchIcon = (props)=>/*#__PURE__*/ $c2acafe292c67b9a$var$_react.default.createElement($c2acafe292c67b9a$var$_baseNew.default, Object.assign({
        name: "BranchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122V9H3.5V5.372A2.25 2.25 0 0 1 2 3.25m9.75-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.25.75a2.25 2.25 0 1 1 3 2.122v4.878a3.25 3.25 0 0 1-3.25 3.25H6.372a2.25 2.25 0 1 1 0-1.5H9.25A1.75 1.75 0 0 0 11 10.25V5.372A2.25 2.25 0 0 1 9.5 3.25M4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$c2acafe292c67b9a$var$BranchIcon.displayName = 'BranchIcon';
var $c2acafe292c67b9a$var$_default = module.exports.default = $c2acafe292c67b9a$var$BranchIcon;

});

parcelRegister("hQhpy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cefb20804c6157bd06515342b7995dfa>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cfd4cc7d382baa9b$var$_react = $cfd4cc7d382baa9b$var$_interopRequireDefault((parcelRequire("cozmU")));

var $cfd4cc7d382baa9b$var$_baseNew = $cfd4cc7d382baa9b$var$_interopRequireDefault((parcelRequire("gElAV")));
function $cfd4cc7d382baa9b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PullRequest".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/pull-request
 * Usage guidance:
 * Single purpose - Reserved for pull requests.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cfd4cc7d382baa9b$var$PullRequestIcon = (props)=>/*#__PURE__*/ $cfd4cc7d382baa9b$var$_react.default.createElement($cfd4cc7d382baa9b$var$_baseNew.default, Object.assign({
        name: "PullRequestIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122v5.256a2.251 2.251 0 1 1-1.5 0V5.372A2.25 2.25 0 0 1 2 3.25m6-.75h1.75a2.75 2.75 0 0 1 2.75 2.75v5.378a2.251 2.251 0 1 1-1.5 0V5.25C11 4.56 10.44 4 9.75 4H8zM4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m7.5 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$cfd4cc7d382baa9b$var$PullRequestIcon.displayName = 'PullRequestIcon';
var $cfd4cc7d382baa9b$var$_default = module.exports.default = $cfd4cc7d382baa9b$var$PullRequestIcon;

});

parcelRegister("d0CGr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::055ea334ffeb6fe55258f9aa906da082>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9789483490e5b805$var$_react = $9789483490e5b805$var$_interopRequireDefault((parcelRequire("cozmU")));

var $9789483490e5b805$var$_baseNew = $9789483490e5b805$var$_interopRequireDefault((parcelRequire("gElAV")));
function $9789483490e5b805$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckboxChecked".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/checkbox-checked
 * Usage guidance:
 * Multi purpose - Reserved for interactive checkbox experiences. Consider using the checkbox component.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9789483490e5b805$var$CheckboxCheckedIcon = (props)=>/*#__PURE__*/ $9789483490e5b805$var$_react.default.createElement($9789483490e5b805$var$_baseNew.default, Object.assign({
        name: "CheckboxCheckedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm9.326 4.48-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$9789483490e5b805$var$CheckboxCheckedIcon.displayName = 'CheckboxCheckedIcon';
var $9789483490e5b805$var$_default = module.exports.default = $9789483490e5b805$var$CheckboxCheckedIcon;

});

parcelRegister("chu6R", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43780b3395052aa320d1077123ecca9b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8f0e6dbb060c87fb$var$_react = $8f0e6dbb060c87fb$var$_interopRequireDefault((parcelRequire("cozmU")));

var $8f0e6dbb060c87fb$var$_baseNew = $8f0e6dbb060c87fb$var$_interopRequireDefault((parcelRequire("gElAV")));
function $8f0e6dbb060c87fb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/status-success
 * Usage guidance:
 * Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8f0e6dbb060c87fb$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $8f0e6dbb060c87fb$var$_react.default.createElement($8f0e6dbb060c87fb$var$_baseNew.default, Object.assign({
        name: "StatusSuccessIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$8f0e6dbb060c87fb$var$StatusSuccessIcon.displayName = 'StatusSuccessIcon';
var $8f0e6dbb060c87fb$var$_default = module.exports.default = $8f0e6dbb060c87fb$var$StatusSuccessIcon;

});

parcelRegister("eh6Ml", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::948526006d27d48bcd24e662b224371e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a647e95094993e72$var$_react = $a647e95094993e72$var$_interopRequireDefault((parcelRequire("cozmU")));

var $a647e95094993e72$var$_baseNew = $a647e95094993e72$var$_interopRequireDefault((parcelRequire("gElAV")));
function $a647e95094993e72$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/check-mark
 * Usage guidance:
 * Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a647e95094993e72$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $a647e95094993e72$var$_react.default.createElement($a647e95094993e72$var$_baseNew.default, Object.assign({
        name: "CheckMarkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m13.959 3.97-7.25 9a.75.75 0 0 1-1.163.007l-3.5-4.25 1.158-.954 2.914 3.539 6.673-8.283z"/>`
    }, props));
$a647e95094993e72$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $a647e95094993e72$var$_default = module.exports.default = $a647e95094993e72$var$CheckMarkIcon;

});

parcelRegister("aDSIl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ae4272f6629317895b037fe9aca7fab1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7bf7fd06244bc78b$var$_react = $7bf7fd06244bc78b$var$_interopRequireDefault((parcelRequire("cozmU")));

var $7bf7fd06244bc78b$var$_baseNew = $7bf7fd06244bc78b$var$_interopRequireDefault((parcelRequire("gElAV")));
function $7bf7fd06244bc78b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/chevron-right
 * Usage guidance:
 * Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
 * Known uses: Next page of pagination results, collapsed tree item, expand tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7bf7fd06244bc78b$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $7bf7fd06244bc78b$var$_react.default.createElement($7bf7fd06244bc78b$var$_baseNew.default, Object.assign({
        name: "ChevronRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m6.03 1.47 6 6a.75.75 0 0 1 .052 1.004l-.052.056-6 6-1.06-1.06L10.44 8 4.97 2.53z"/>`
    }, props));
$7bf7fd06244bc78b$var$ChevronRightIcon.displayName = 'ChevronRightIcon';
var $7bf7fd06244bc78b$var$_default = module.exports.default = $7bf7fd06244bc78b$var$ChevronRightIcon;

});

parcelRegister("j6vyT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d43da111d5da2bc4c58e22bdbb274e37>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $de870f5d9b9daaf3$var$_react = $de870f5d9b9daaf3$var$_interopRequireDefault((parcelRequire("cozmU")));

var $de870f5d9b9daaf3$var$_baseNew = $de870f5d9b9daaf3$var$_interopRequireDefault((parcelRequire("gElAV")));
function $de870f5d9b9daaf3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/chevron-up
 * Usage guidance:
 * Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
 * Known uses: Close dropdown menu
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $de870f5d9b9daaf3$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $de870f5d9b9daaf3$var$_react.default.createElement($de870f5d9b9daaf3$var$_baseNew.default, Object.assign({
        name: "ChevronUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 9.97-6-6a.75.75 0 0 0-1.004-.052l-.056.052-6 6 1.06 1.06L8 5.56l5.47 5.47z"/>`
    }, props));
$de870f5d9b9daaf3$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
var $de870f5d9b9daaf3$var$_default = module.exports.default = $de870f5d9b9daaf3$var$ChevronUpIcon;

});

parcelRegister("hZR9z", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::162737b31e7d0d957301c4a3af125700>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d1a15d4f4ee357ff$var$_react = $d1a15d4f4ee357ff$var$_interopRequireDefault((parcelRequire("cozmU")));

var $d1a15d4f4ee357ff$var$_baseNew = $d1a15d4f4ee357ff$var$_interopRequireDefault((parcelRequire("gElAV")));
function $d1a15d4f4ee357ff$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignImageCenter".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/align-image-center
 * Usage guidance:
 * Single purpose - Reserved for center aligning media and content.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d1a15d4f4ee357ff$var$AlignImageCenterIcon = (props)=>/*#__PURE__*/ $d1a15d4f4ee357ff$var$_react.default.createElement($d1a15d4f4ee357ff$var$_baseNew.default, Object.assign({
        name: "AlignImageCenterIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.5H1V1h14zm-8.5 4v3h3v-3zM6.375 5h3.25C10.385 5 11 5.616 11 6.375v3.25c0 .76-.616 1.375-1.375 1.375h-3.25C5.615 11 5 10.384 5 9.625v-3.25C5 5.615 5.616 5 6.375 5M15 15H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$d1a15d4f4ee357ff$var$AlignImageCenterIcon.displayName = 'AlignImageCenterIcon';
var $d1a15d4f4ee357ff$var$_default = module.exports.default = $d1a15d4f4ee357ff$var$AlignImageCenterIcon;

});

parcelRegister("6aEgq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0fadab2de228b8fed272ebec34ce7b4e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $47e2e8d6645bff9f$var$_react = $47e2e8d6645bff9f$var$_interopRequireDefault((parcelRequire("cozmU")));

var $47e2e8d6645bff9f$var$_baseNew = $47e2e8d6645bff9f$var$_interopRequireDefault((parcelRequire("gElAV")));
function $47e2e8d6645bff9f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignImageLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/align-image-left
 * Usage guidance:
 * Single purpose - Reserved for left aligning media and content.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $47e2e8d6645bff9f$var$AlignImageLeftIcon = (props)=>/*#__PURE__*/ $47e2e8d6645bff9f$var$_react.default.createElement($47e2e8d6645bff9f$var$_baseNew.default, Object.assign({
        name: "AlignImageLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.5H1V1h14zm-12.5 4v3h3v-3zM2.375 5h3.25C6.385 5 7 5.616 7 6.375v3.25C7 10.385 6.384 11 5.625 11h-3.25C1.615 11 1 10.384 1 9.625v-3.25C1 5.615 1.616 5 2.375 5M15 15H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$47e2e8d6645bff9f$var$AlignImageLeftIcon.displayName = 'AlignImageLeftIcon';
var $47e2e8d6645bff9f$var$_default = module.exports.default = $47e2e8d6645bff9f$var$AlignImageLeftIcon;

});

parcelRegister("b391T", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5ba705688109fe6cba23e367fcc7db14>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $80b6fa9826be4ac9$var$_react = $80b6fa9826be4ac9$var$_interopRequireDefault((parcelRequire("cozmU")));

var $80b6fa9826be4ac9$var$_baseNew = $80b6fa9826be4ac9$var$_interopRequireDefault((parcelRequire("gElAV")));
function $80b6fa9826be4ac9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PaintBucket".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/paint-bucket
 * Usage guidance:
 * Multi purpose - Known usages: Customize fill color.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $80b6fa9826be4ac9$var$PaintBucketIcon = (props)=>/*#__PURE__*/ $80b6fa9826be4ac9$var$_react.default.createElement($80b6fa9826be4ac9$var$_baseNew.default, Object.assign({
        name: "PaintBucketIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.5 1.94 6.78.66A1.38 1.38 0 0 1 8.62.57l.11.09 5.62 5.62a1.38 1.38 0 0 1 0 1.95l-5.73 5.73a2.63 2.63 0 0 1-3.71 0l-3.85-3.85a2.63 2.63 0 0 1 0-3.71L4.44 3 2.6 1.15 3.66.09zM1.81 8.5c.05.2.14.39.3.55l3.85 3.85c.44.44 1.15.44 1.59 0l4.39-4.39zM6.57 3l1.22 1.22-1.06 1.06L5.5 4.06 2.56 7h10.38L7.75 1.81zm7.68 8.25c.27 0 .52.14.65.38v.01l.01.02.03.06.12.21c.1.18.23.42.36.68s.27.55.37.82c.09.23.21.56.21.86 0 .97-.8 1.73-1.75 1.73s-1.75-.75-1.75-1.72c0-.29.12-.63.21-.86.11-.27.24-.56.37-.82s.26-.5.36-.68l.12-.21.03-.06.01-.02v-.01a.75.75 0 0 1 .65-.38"/>`
    }, props));
$80b6fa9826be4ac9$var$PaintBucketIcon.displayName = 'PaintBucketIcon';
var $80b6fa9826be4ac9$var$_default = module.exports.default = $80b6fa9826be4ac9$var$PaintBucketIcon;

});

parcelRegister("l3wuH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cdf99897c5696ca9ecbe3cd832bc46f8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f54315766ddd360d$var$_react = $f54315766ddd360d$var$_interopRequireDefault((parcelRequire("cozmU")));

var $f54315766ddd360d$var$_baseNew = $f54315766ddd360d$var$_interopRequireDefault((parcelRequire("gElAV")));
function $f54315766ddd360d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/cross
 * Usage guidance:
 * Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f54315766ddd360d$var$CrossIcon = (props)=>/*#__PURE__*/ $f54315766ddd360d$var$_react.default.createElement($f54315766ddd360d$var$_baseNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.53 3.53 9.06 8l4.47 4.47-1.06 1.06L8 9.06l-4.47 4.47-1.06-1.06L6.94 8 2.47 3.53l1.06-1.06L8 6.94l4.47-4.47z"/>`
    }, props));
$f54315766ddd360d$var$CrossIcon.displayName = 'CrossIcon';
var $f54315766ddd360d$var$_default = module.exports.default = $f54315766ddd360d$var$CrossIcon;

});

parcelRegister("hade9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9184bb09613e9a96c3112241b89bd1e6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c7eda184d694307c$var$_react = $c7eda184d694307c$var$_interopRequireDefault((parcelRequire("cozmU")));

var $c7eda184d694307c$var$_baseNew = $c7eda184d694307c$var$_interopRequireDefault((parcelRequire("gElAV")));
function $c7eda184d694307c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Minus".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/minus
 * Usage guidance:
 * Multi purpose - Known uses: horizontal rule in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c7eda184d694307c$var$MinusIcon = (props)=>/*#__PURE__*/ $c7eda184d694307c$var$_react.default.createElement($c7eda184d694307c$var$_baseNew.default, Object.assign({
        name: "MinusIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 8.75H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$c7eda184d694307c$var$MinusIcon.displayName = 'MinusIcon';
var $c7eda184d694307c$var$_default = module.exports.default = $c7eda184d694307c$var$MinusIcon;

});

parcelRegister("5avUB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c0d7fdaf9327a5409e2e4c35dd4346a6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3c36a3fba985c860$var$_react = $3c36a3fba985c860$var$_interopRequireDefault((parcelRequire("cozmU")));

var $3c36a3fba985c860$var$_baseNew = $3c36a3fba985c860$var$_interopRequireDefault((parcelRequire("gElAV")));
function $3c36a3fba985c860$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/cross-circle
 * Usage guidance:
 * Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3c36a3fba985c860$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $3c36a3fba985c860$var$_react.default.createElement($3c36a3fba985c860$var$_baseNew.default, Object.assign({
        name: "CrossCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0m0 6.94L5.03 3.97 3.97 5.03 6.94 8l-2.97 2.97 1.06 1.06L8 9.06l2.97 2.97 1.06-1.06L9.06 8l2.97-2.97-1.06-1.06z" clip-rule="evenodd"/>`
    }, props));
$3c36a3fba985c860$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $3c36a3fba985c860$var$_default = module.exports.default = $3c36a3fba985c860$var$CrossCircleIcon;

});

parcelRegister("dLFT2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::882cf79de950c45ed407753b2a867c40>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a06027f4f5f7c981$var$_react = $a06027f4f5f7c981$var$_interopRequireDefault((parcelRequire("cozmU")));

var $a06027f4f5f7c981$var$_baseNew = $a06027f4f5f7c981$var$_interopRequireDefault((parcelRequire("gElAV")));
function $a06027f4f5f7c981$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "GrowHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/grow-horizontal
 * Usage guidance:
 * Single purpose - Reserved for increasing the width of an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a06027f4f5f7c981$var$GrowHorizontalIcon = (props)=>/*#__PURE__*/ $a06027f4f5f7c981$var$_react.default.createElement($a06027f4f5f7c981$var$_baseNew.default, Object.assign({
        name: "GrowHorizontalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m.22 7.47 3.5-3.5 1.06 1.06-2.22 2.22H7v1.5H2.56l2.22 2.22-1.06 1.06-3.5-3.5a.75.75 0 0 1 0-1.06m13.22-.22-2.22-2.22 1.06-1.06 3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5-1.06-1.06 2.22-2.22H9v-1.5z" clip-rule="evenodd"/>`
    }, props));
$a06027f4f5f7c981$var$GrowHorizontalIcon.displayName = 'GrowHorizontalIcon';
var $a06027f4f5f7c981$var$_default = module.exports.default = $a06027f4f5f7c981$var$GrowHorizontalIcon;

});

parcelRegister("gVrmv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::438a97f59a6ff2783bbf26f581467704>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c52731bdd0638e43$var$_react = $c52731bdd0638e43$var$_interopRequireDefault((parcelRequire("cozmU")));

var $c52731bdd0638e43$var$_baseNew = $c52731bdd0638e43$var$_interopRequireDefault((parcelRequire("gElAV")));
function $c52731bdd0638e43$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Feedback".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/feedback
 * Usage guidance:
 * Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c52731bdd0638e43$var$FeedbackIcon = (props)=>/*#__PURE__*/ $c52731bdd0638e43$var$_react.default.createElement($c52731bdd0638e43$var$_baseNew.default, Object.assign({
        name: "FeedbackIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6.221l-4.064 2.63A.75.75 0 0 1 1 15V9.5h1.5v4.121l3.093-2A.75.75 0 0 1 6 11.5h7a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2.75a.5.5 0 0 0 .5.5h5.44L7.22 5.03l1.06-1.06 2.5 2.5a.75.75 0 0 1 0 1.06l-2.5 2.5-1.06-1.06 1.22-1.22H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$c52731bdd0638e43$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $c52731bdd0638e43$var$_default = module.exports.default = $c52731bdd0638e43$var$FeedbackIcon;

});

parcelRegister("gaHi2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::475edd236d66c0bbecc3eb1393d05b9d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bc5f28fde5cec065$var$_react = $bc5f28fde5cec065$var$_interopRequireDefault((parcelRequire("cozmU")));

var $bc5f28fde5cec065$var$_baseNew = $bc5f28fde5cec065$var$_interopRequireDefault((parcelRequire("gElAV")));
function $bc5f28fde5cec065$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextIndentRight".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/text-indent-right
 * Usage guidance:
 * Single purpose - Reserved for shifting the indent of text content right.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bc5f28fde5cec065$var$TextIndentRightIcon = (props)=>/*#__PURE__*/ $bc5f28fde5cec065$var$_react.default.createElement($bc5f28fde5cec065$var$_baseNew.default, Object.assign({
        name: "TextIndentRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.5H1V1h14zM2.03 4.72l2.75 2.75a.75.75 0 0 1 0 1.06l-2.75 2.75-1.06-1.06L3.19 8 .97 5.78zM15 6.667H8v-1.5h7zm0 4.166H8v-1.5h7zm0 2.667V15H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$bc5f28fde5cec065$var$TextIndentRightIcon.displayName = 'TextIndentRightIcon';
var $bc5f28fde5cec065$var$_default = module.exports.default = $bc5f28fde5cec065$var$TextIndentRightIcon;

});

parcelRegister("8p5GO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::08a6c5938ffca48724ffb7cb03500605>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $61e5125d48194b97$var$_react = $61e5125d48194b97$var$_interopRequireDefault((parcelRequire("cozmU")));

var $61e5125d48194b97$var$_baseNew = $61e5125d48194b97$var$_interopRequireDefault((parcelRequire("gElAV")));
function $61e5125d48194b97$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutOneColumn".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/layout-one-column
 * Usage guidance:
 * Reserved for single column layout option in Confluence Editor
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $61e5125d48194b97$var$LayoutOneColumnIcon = (props)=>/*#__PURE__*/ $61e5125d48194b97$var$_react.default.createElement($61e5125d48194b97$var$_baseNew.default, Object.assign({
        name: "LayoutOneColumnIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h13.25C15.385 1 16 1.616 16 2.375v11.25c0 .76-.616 1.375-1.375 1.375H1.375C.615 15 0 14.384 0 13.625zm1.5.125v11h13v-11z" clip-rule="evenodd"/>`
    }, props));
$61e5125d48194b97$var$LayoutOneColumnIcon.displayName = 'LayoutOneColumnIcon';
var $61e5125d48194b97$var$_default = module.exports.default = $61e5125d48194b97$var$LayoutOneColumnIcon;

});

parcelRegister("fHdH6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9de5c8fa7629c4a1086812b613d00b0c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b6d57e86a7f69f32$var$_react = $b6d57e86a7f69f32$var$_interopRequireDefault((parcelRequire("cozmU")));

var $b6d57e86a7f69f32$var$_baseNew = $b6d57e86a7f69f32$var$_interopRequireDefault((parcelRequire("gElAV")));
function $b6d57e86a7f69f32$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutThreeColumns".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/layout-three-columns
 * Usage guidance:
 * Single purpose - Reserved for 3 column layout option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b6d57e86a7f69f32$var$LayoutThreeColumnsIcon = (props)=>/*#__PURE__*/ $b6d57e86a7f69f32$var$_react.default.createElement($b6d57e86a7f69f32$var$_baseNew.default, Object.assign({
        name: "LayoutThreeColumnsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h1.5c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-1.5C.615 15 0 14.384 0 13.625zm1.5.125v11h1.25v-11zm4.25-.125C5.75 1.615 6.366 1 7.125 1h1.75c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-1.75c-.76 0-1.375-.616-1.375-1.375zm1.5.125v11h1.5v-11zm4.5-.125c0-.76.616-1.375 1.375-1.375h1.5C15.385 1 16 1.616 16 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-1.5c-.76 0-1.375-.616-1.375-1.375zm1.5.125v11h1.25v-11z" clip-rule="evenodd"/>`
    }, props));
$b6d57e86a7f69f32$var$LayoutThreeColumnsIcon.displayName = 'LayoutThreeColumnsIcon';
var $b6d57e86a7f69f32$var$_default = module.exports.default = $b6d57e86a7f69f32$var$LayoutThreeColumnsIcon;

});

parcelRegister("5skpJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ec032b9005af41dc45bdcbf1a0c9d1f4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3f8f67104ee3e987$var$_react = $3f8f67104ee3e987$var$_interopRequireDefault((parcelRequire("cozmU")));

var $3f8f67104ee3e987$var$_baseNew = $3f8f67104ee3e987$var$_interopRequireDefault((parcelRequire("gElAV")));
function $3f8f67104ee3e987$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutThreeColumnsSidebars".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/layout-three-columns-sidebars
 * Usage guidance:
 * Single purpose - Reserved for 3 column layout with left and right sidebars option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3f8f67104ee3e987$var$LayoutThreeColumnsSidebarsIcon = (props)=>/*#__PURE__*/ $3f8f67104ee3e987$var$_react.default.createElement($3f8f67104ee3e987$var$_baseNew.default, Object.assign({
        name: "LayoutThreeColumnsSidebarsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h.75c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-.75C.615 15 0 14.384 0 13.625zm1.5.125v11H2v-11zM5 2.375C5 1.615 5.616 1 6.375 1h3.25C10.385 1 11 1.616 11 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-3.25C5.615 15 5 14.384 5 13.625zm1.5.125v11h3v-11zm6-.125c0-.76.616-1.375 1.375-1.375h.75C15.385 1 16 1.616 16 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-.75c-.76 0-1.375-.616-1.375-1.375zM14 2.5v11h.5v-11z" clip-rule="evenodd"/>`
    }, props));
$3f8f67104ee3e987$var$LayoutThreeColumnsSidebarsIcon.displayName = 'LayoutThreeColumnsSidebarsIcon';
var $3f8f67104ee3e987$var$_default = module.exports.default = $3f8f67104ee3e987$var$LayoutThreeColumnsSidebarsIcon;

});

parcelRegister("eQpqk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fedc57cc50359dc48cb5f8d2f8dc3fbe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ace9a49b60337c3d$var$_react = $ace9a49b60337c3d$var$_interopRequireDefault((parcelRequire("cozmU")));

var $ace9a49b60337c3d$var$_baseNew = $ace9a49b60337c3d$var$_interopRequireDefault((parcelRequire("gElAV")));
function $ace9a49b60337c3d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutTwoColumns".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/layout-two-columns
 * Usage guidance:
 * Single purpose - Reserved for 2 column layout option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ace9a49b60337c3d$var$LayoutTwoColumnsIcon = (props)=>/*#__PURE__*/ $ace9a49b60337c3d$var$_react.default.createElement($ace9a49b60337c3d$var$_baseNew.default, Object.assign({
        name: "LayoutTwoColumnsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h4.5c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-4.5C.615 15 0 14.384 0 13.625zm1.5.125v11h4.25v-11zm7.25-.125c0-.76.616-1.375 1.375-1.375h4.5C15.385 1 16 1.616 16 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-4.5c-.76 0-1.375-.616-1.375-1.375zm1.5.125v11h4.25v-11z" clip-rule="evenodd"/>`
    }, props));
$ace9a49b60337c3d$var$LayoutTwoColumnsIcon.displayName = 'LayoutTwoColumnsIcon';
var $ace9a49b60337c3d$var$_default = module.exports.default = $ace9a49b60337c3d$var$LayoutTwoColumnsIcon;

});

parcelRegister("fWx9I", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9177f87021bd510676cd2e745666ca1c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b9b5fdcdb752364f$var$_react = $b9b5fdcdb752364f$var$_interopRequireDefault((parcelRequire("cozmU")));

var $b9b5fdcdb752364f$var$_baseNew = $b9b5fdcdb752364f$var$_interopRequireDefault((parcelRequire("gElAV")));
function $b9b5fdcdb752364f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutTwoColumnsSidebarLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/layout-two-columns-sidebar-left
 * Usage guidance:
 * Single purpose - Reserved for 2 column layout with left sidebar option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b9b5fdcdb752364f$var$LayoutTwoColumnsSidebarLeftIcon = (props)=>/*#__PURE__*/ $b9b5fdcdb752364f$var$_react.default.createElement($b9b5fdcdb752364f$var$_baseNew.default, Object.assign({
        name: "LayoutTwoColumnsSidebarLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 2.375C16 1.615 15.384 1 14.625 1h-7.75C6.115 1 5.5 1.616 5.5 2.375v11.25c0 .76.616 1.375 1.375 1.375h7.75c.76 0 1.375-.616 1.375-1.375zm-1.5.125v11H7v-11zM4 2.375C4 1.615 3.384 1 2.625 1h-1.25C.615 1 0 1.616 0 2.375v11.25C0 14.385.616 15 1.375 15h1.25C3.385 15 4 14.384 4 13.625zM2.5 2.5v11h-1v-11z" clip-rule="evenodd"/>`
    }, props));
$b9b5fdcdb752364f$var$LayoutTwoColumnsSidebarLeftIcon.displayName = 'LayoutTwoColumnsSidebarLeftIcon';
var $b9b5fdcdb752364f$var$_default = module.exports.default = $b9b5fdcdb752364f$var$LayoutTwoColumnsSidebarLeftIcon;

});

parcelRegister("9V98o", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::168d8e3194cb943a547278de785a58eb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $739085d29a48f558$var$_react = $739085d29a48f558$var$_interopRequireDefault((parcelRequire("cozmU")));

var $739085d29a48f558$var$_baseNew = $739085d29a48f558$var$_interopRequireDefault((parcelRequire("gElAV")));
function $739085d29a48f558$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ExpandHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/expand-horizontal
 * Usage guidance:
 * Single purpose - Reserved for expanding an element to its maximum width.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $739085d29a48f558$var$ExpandHorizontalIcon = (props)=>/*#__PURE__*/ $739085d29a48f558$var$_react.default.createElement($739085d29a48f558$var$_baseNew.default, Object.assign({
        name: "ExpandHorizontalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1.5 1v14H0V1zM16 1v14h-1.5V1zm-1.72 6.47a.75.75 0 0 1 0 1.06l-3.25 3.25-1.06-1.06 1.97-1.97H4.06l1.97 1.97-1.06 1.06-3.25-3.25a.75.75 0 0 1 0-1.06l3.25-3.25 1.06 1.06-1.97 1.97h7.88L9.97 5.28l1.06-1.06z"/>`
    }, props));
$739085d29a48f558$var$ExpandHorizontalIcon.displayName = 'ExpandHorizontalIcon';
var $739085d29a48f558$var$_default = module.exports.default = $739085d29a48f558$var$ExpandHorizontalIcon;

});

parcelRegister("f4MCV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7b91f5fed9019780e0c1ca8c80f40e9a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $af9cf300277396b8$var$_react = $af9cf300277396b8$var$_interopRequireDefault((parcelRequire("cozmU")));

var $af9cf300277396b8$var$_baseNew = $af9cf300277396b8$var$_interopRequireDefault((parcelRequire("gElAV")));
function $af9cf300277396b8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ContentWrapLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/content-wrap-left
 * Usage guidance:
 * Single purpose - Reserved for left aligning media and content with wrapping enabled.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $af9cf300277396b8$var$ContentWrapLeftIcon = (props)=>/*#__PURE__*/ $af9cf300277396b8$var$_react.default.createElement($af9cf300277396b8$var$_baseNew.default, Object.assign({
        name: "ContentWrapLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.5H1V1h14zm-12.5 4v3h3v-3zM2.375 5h3.25C6.385 5 7 5.616 7 6.375v3.25C7 10.385 6.384 11 5.625 11h-3.25C1.615 11 1 10.384 1 9.625v-3.25C1 5.615 1.616 5 2.375 5M15 6.667H9v-1.5h6zm0 4.166H9v-1.5h6zM15 15H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$af9cf300277396b8$var$ContentWrapLeftIcon.displayName = 'ContentWrapLeftIcon';
var $af9cf300277396b8$var$_default = module.exports.default = $af9cf300277396b8$var$ContentWrapLeftIcon;

});

parcelRegister("iUhs4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::03af74fb04b6dd0c78ef1201d18a54e5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dc3afe7f9d2377ab$var$_react = $dc3afe7f9d2377ab$var$_interopRequireDefault((parcelRequire("cozmU")));

var $dc3afe7f9d2377ab$var$_baseNew = $dc3afe7f9d2377ab$var$_interopRequireDefault((parcelRequire("gElAV")));
function $dc3afe7f9d2377ab$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ContentWrapRight".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/content-wrap-right
 * Usage guidance:
 * Single purpose - Reserved for right aligning media and content with wrapping enabled.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dc3afe7f9d2377ab$var$ContentWrapRightIcon = (props)=>/*#__PURE__*/ $dc3afe7f9d2377ab$var$_react.default.createElement($dc3afe7f9d2377ab$var$_baseNew.default, Object.assign({
        name: "ContentWrapRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.5H1V1h14zm-4.5 4v3h3v-3zM10.375 5h3.25C14.385 5 15 5.616 15 6.375v3.25c0 .76-.616 1.375-1.375 1.375h-3.25C9.615 11 9 10.384 9 9.625v-3.25C9 5.615 9.616 5 10.375 5M7 6.667H1v-1.5h6zm0 4.166H1v-1.5h6zM15 15H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$dc3afe7f9d2377ab$var$ContentWrapRightIcon.displayName = 'ContentWrapRightIcon';
var $dc3afe7f9d2377ab$var$_default = module.exports.default = $dc3afe7f9d2377ab$var$ContentWrapRightIcon;

});

parcelRegister("hMv2K", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d928db7ad5881269ecf1c92ab19bca71>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cf1efff0709b634b$var$_react = $cf1efff0709b634b$var$_interopRequireDefault((parcelRequire("cozmU")));

var $cf1efff0709b634b$var$_baseNew = $cf1efff0709b634b$var$_interopRequireDefault((parcelRequire("gElAV")));
function $cf1efff0709b634b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Mention".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/mention
 * Usage guidance:
 * Single purpose - Reserved for user mentions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cf1efff0709b634b$var$MentionIcon = (props)=>/*#__PURE__*/ $cf1efff0709b634b$var$_react.default.createElement($cf1efff0709b634b$var$_baseNew.default, Object.assign({
        name: "MentionIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 3.25 12.13l.75 1.3A8 8 0 1 1 16 8c0 .842-.28 1.775-.817 2.513-.547.751-1.401 1.344-2.522 1.344-.577 0-1.07-.177-1.462-.507a2.5 2.5 0 0 1-.66-.908C9.387 11.776 7.529 12.346 6 11.464 4.229 10.441 3.926 8.057 4.969 6.25S8.229 3.513 10 4.536c1.12.647 1.66 1.87 1.633 3.105l-.005.13c0 .687.038 1.397.226 1.923.091.255.201.415.313.51.098.083.242.153.494.153.536 0 .976-.27 1.31-.727.342-.47.529-1.091.529-1.63A6.5 6.5 0 0 0 8 1.5m2.133 6.102c.015-.798-.328-1.447-.883-1.767C8.39 5.339 7.02 5.698 6.268 7s-.377 2.67.482 3.165c.86.496 2.23.137 2.982-1.165.244-.422.37-.866.397-1.287z" clip-rule="evenodd"/>`
    }, props));
$cf1efff0709b634b$var$MentionIcon.displayName = 'MentionIcon';
var $cf1efff0709b634b$var$_default = module.exports.default = $cf1efff0709b634b$var$MentionIcon;

});

parcelRegister("6TaGl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ec1b1ad1c034dad44344f797e0630b31>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $50402a5b61dc5868$var$_react = $50402a5b61dc5868$var$_interopRequireDefault((parcelRequire("cozmU")));

var $50402a5b61dc5868$var$_baseNew = $50402a5b61dc5868$var$_interopRequireDefault((parcelRequire("gElAV")));
function $50402a5b61dc5868$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShowMoreHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/show-more-horizontal
 * Usage guidance:
 * Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $50402a5b61dc5868$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $50402a5b61dc5868$var$_react.default.createElement($50402a5b61dc5868$var$_baseNew.default, Object.assign({
        name: "ShowMoreHorizontalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m6.5 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M13 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" clip-rule="evenodd"/>`
    }, props));
$50402a5b61dc5868$var$ShowMoreHorizontalIcon.displayName = 'ShowMoreHorizontalIcon';
var $50402a5b61dc5868$var$_default = module.exports.default = $50402a5b61dc5868$var$ShowMoreHorizontalIcon;

});

parcelRegister("d4GYd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e81309f7972e382533b4307ab6b9a3ef>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $984cfb18cceede4c$var$_react = $984cfb18cceede4c$var$_interopRequireDefault((parcelRequire("cozmU")));

var $984cfb18cceede4c$var$_baseNew = $984cfb18cceede4c$var$_interopRequireDefault((parcelRequire("gElAV")));
function $984cfb18cceede4c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuotationMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/quotation-mark
 * Usage guidance:
 * Multi purpose - Known uses: blockquote, comment, testimonial, blogs in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $984cfb18cceede4c$var$QuotationMarkIcon = (props)=>/*#__PURE__*/ $984cfb18cceede4c$var$_react.default.createElement($984cfb18cceede4c$var$_baseNew.default, Object.assign({
        name: "QuotationMarkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v6a4 4 0 0 1-4 4v-1.5A2.5 2.5 0 0 0 5.5 10V9H2a2 2 0 0 1-2-2zm5.5 3.5V4a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5zM9 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v6a4 4 0 0 1-4 4v-1.5a2.5 2.5 0 0 0 2.5-2.5V9H11a2 2 0 0 1-2-2zm5.5 3.5V4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5z" clip-rule="evenodd"/>`
    }, props));
$984cfb18cceede4c$var$QuotationMarkIcon.displayName = 'QuotationMarkIcon';
var $984cfb18cceede4c$var$_default = module.exports.default = $984cfb18cceede4c$var$QuotationMarkIcon;

});

parcelRegister("bAKDg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::74bfdc6e5cc366cfb267c5cd5d54201b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $87073ab0294bc821$var$_react = $87073ab0294bc821$var$_interopRequireDefault((parcelRequire("cozmU")));

var $87073ab0294bc821$var$_baseNew = $87073ab0294bc821$var$_interopRequireDefault((parcelRequire("gElAV")));
function $87073ab0294bc821$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Redo".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/redo
 * Usage guidance:
 * Single purpose - Reserved for redo in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $87073ab0294bc821$var$RedoIcon = (props)=>/*#__PURE__*/ $87073ab0294bc821$var$_react.default.createElement($87073ab0294bc821$var$_baseNew.default, Object.assign({
        name: "RedoIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m14.78 4.72-3.5-3.5-1.06 1.06 2.22 2.22H5.75a4.75 4.75 0 0 0 0 9.5H8v-1.5H5.75a3.25 3.25 0 0 1 0-6.5h6.69l-2.22 2.22 1.06 1.06 3.5-3.5a.75.75 0 0 0 0-1.06" clip-rule="evenodd"/>`
    }, props));
$87073ab0294bc821$var$RedoIcon.displayName = 'RedoIcon';
var $87073ab0294bc821$var$_default = module.exports.default = $87073ab0294bc821$var$RedoIcon;

});

parcelRegister("iDfTs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4d66dd1931c60e88592e7dfad0d4d211>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d908329d870b01bb$var$_react = $d908329d870b01bb$var$_interopRequireDefault((parcelRequire("cozmU")));

var $d908329d870b01bb$var$_baseNew = $d908329d870b01bb$var$_interopRequireDefault((parcelRequire("gElAV")));
function $d908329d870b01bb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Delete".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/delete
 * Usage guidance:
 * Single purpose - Reserved for removing or deleting an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d908329d870b01bb$var$DeleteIcon = (props)=>/*#__PURE__*/ $d908329d870b01bb$var$_react.default.createElement($d908329d870b01bb$var$_baseNew.default, Object.assign({
        name: "DeleteIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 .75A.75.75 0 0 1 5.75 0h4.5a.75.75 0 0 1 .75.75V2.5h3.5V4h-1v10a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2V4h-1V2.5H5zM6.5 2.5h3v-1h-3zM4 4v10a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V4zm1.75 9V5.5h1.5V13zm3 0V5.5h1.5V13z" clip-rule="evenodd"/>`
    }, props));
$d908329d870b01bb$var$DeleteIcon.displayName = 'DeleteIcon';
var $d908329d870b01bb$var$_default = module.exports.default = $d908329d870b01bb$var$DeleteIcon;

});

parcelRegister("k0CUL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::301ac66db780a5585809ca98bb4909df>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e911fe5666b98d96$var$_react = $e911fe5666b98d96$var$_interopRequireDefault((parcelRequire("cozmU")));

var $e911fe5666b98d96$var$_baseNew = $e911fe5666b98d96$var$_interopRequireDefault((parcelRequire("gElAV")));
function $e911fe5666b98d96$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Grid".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/grid
 * Usage guidance:
 * Multi purpose - Known uses: spaces in Confluence, and grid view, all content in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e911fe5666b98d96$var$GridIcon = (props)=>/*#__PURE__*/ $e911fe5666b98d96$var$_react.default.createElement($e911fe5666b98d96$var$_baseNew.default, Object.assign({
        name: "GridIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v4.25h4.75V2.5zm5.75 0v4.75h4.75V3a.5.5 0 0 0-.5-.5zm4.75 6.25H8.75v4.75H13a.5.5 0 0 0 .5-.5zM7.25 13.5V8.75H2.5V13a.5.5 0 0 0 .5.5z" clip-rule="evenodd"/>`
    }, props));
$e911fe5666b98d96$var$GridIcon.displayName = 'GridIcon';
var $e911fe5666b98d96$var$_default = module.exports.default = $e911fe5666b98d96$var$GridIcon;

});

parcelRegister("4WfQc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a52c86a83a112cec51a21c145ee6f05a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3988dde290fed314$var$_react = $3988dde290fed314$var$_interopRequireDefault((parcelRequire("cozmU")));

var $3988dde290fed314$var$_baseNew = $3988dde290fed314$var$_interopRequireDefault((parcelRequire("gElAV")));
function $3988dde290fed314$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Heart".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/heart
 * Usage guidance:
 * Multi purpose - Known uses: emoji symbols in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3988dde290fed314$var$HeartIcon = (props)=>/*#__PURE__*/ $3988dde290fed314$var$_react.default.createElement($3988dde290fed314$var$_baseNew.default, Object.assign({
        name: "HeartIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.036 2.75a2.86 2.86 0 0 0-2.144.913 3.3 3.3 0 0 0-.656 1.064A3.9 3.9 0 0 0 2 6.112c0 .83.216 1.666.672 2.518.468.862 1.14 1.722 2.033 2.577q1.344 1.283 3.206 2.475a1 1 0 0 0 .09.047 1 1 0 0 0 .095-.047q1.862-1.193 3.199-2.474c.893-.856 1.563-1.716 2.026-2.578.46-.852.679-1.688.679-2.517 0-.522-.084-.98-.241-1.382l-.003-.007a3.2 3.2 0 0 0-.648-1.06l-.003-.003a2.8 2.8 0 0 0-.95-.672l-.002-.001a2.9 2.9 0 0 0-1.19-.237c-.525 0-.958.133-1.326.382l-.004.002a3 3 0 0 0-.975 1.085l-.66 1.205-.657-1.207a3 3 0 0 0-.971-1.085c-.367-.249-.802-.382-1.334-.382M3.248 1.612a4.4 4.4 0 0 1 1.788-.362c.801 0 1.535.207 2.174.64q.439.296.791.682.356-.388.797-.684c.638-.43 1.37-.638 2.166-.638.63 0 1.229.118 1.787.362q.836.361 1.454 1.028c.414.442.73.962.953 1.549a5.3 5.3 0 0 1 .342 1.923c0 1.105-.294 2.184-.858 3.23-.552 1.025-1.327 2.007-2.31 2.949Q10.87 13.69 8.9 14.948l-.006.004a2 2 0 0 1-.362.18A1.3 1.3 0 0 1 8 15.25c-.205 0-.389-.058-.532-.118a2.3 2.3 0 0 1-.355-.18l-.006-.004q-1.97-1.258-3.438-2.656l-.001-.001c-.983-.941-1.76-1.923-2.316-2.948l-.002-.004C.79 8.294.5 7.216.5 6.112c0-.683.108-1.326.335-1.921l.001-.004a4.8 4.8 0 0 1 .961-1.55 4.4 4.4 0 0 1 1.45-1.025" clip-rule="evenodd"/>`
    }, props));
$3988dde290fed314$var$HeartIcon.displayName = 'HeartIcon';
var $3988dde290fed314$var$_default = module.exports.default = $3988dde290fed314$var$HeartIcon;

});

parcelRegister("bh4C9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b8edab8c982dba06dfc47474975587fa>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8354dc8fbeb45607$var$_react = $8354dc8fbeb45607$var$_interopRequireDefault((parcelRequire("cozmU")));

var $8354dc8fbeb45607$var$_baseNew = $8354dc8fbeb45607$var$_interopRequireDefault((parcelRequire("gElAV")));
function $8354dc8fbeb45607$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Upload".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/upload
 * Usage guidance:
 * Single purpose - Reserved for upload in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8354dc8fbeb45607$var$UploadIcon = (props)=>/*#__PURE__*/ $8354dc8fbeb45607$var$_react.default.createElement($8354dc8fbeb45607$var$_baseNew.default, Object.assign({
        name: "UploadIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.47 1.22a.75.75 0 0 1 1.06 0l4 4-1.06 1.06-2.72-2.72V11h-1.5V3.56L4.53 6.28 3.47 5.22zM1 13V9h1.5v4a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V9H15v4a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2" clip-rule="evenodd"/>`
    }, props));
$8354dc8fbeb45607$var$UploadIcon.displayName = 'UploadIcon';
var $8354dc8fbeb45607$var$_default = module.exports.default = $8354dc8fbeb45607$var$UploadIcon;

});

parcelRegister("9zxkL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::899a5e1306e8987144454772736db49e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6f813d5b1c360eb6$var$_react = $6f813d5b1c360eb6$var$_interopRequireDefault((parcelRequire("cozmU")));

var $6f813d5b1c360eb6$var$_baseNew = $6f813d5b1c360eb6$var$_interopRequireDefault((parcelRequire("gElAV")));
function $6f813d5b1c360eb6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PlusSquare".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/plus-square
 * Usage guidance:
 * Known usages: 'New feature' work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6f813d5b1c360eb6$var$PlusSquareIcon = (props)=>/*#__PURE__*/ $6f813d5b1c360eb6$var$_react.default.createElement($6f813d5b1c360eb6$var$_baseNew.default, Object.assign({
        name: "PlusSquareIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM8.75 4v3.25H12v1.5H8.75V12h-1.5V8.75H4v-1.5h3.25V4zM15 13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>`
    }, props));
$6f813d5b1c360eb6$var$PlusSquareIcon.displayName = 'PlusSquareIcon';
var $6f813d5b1c360eb6$var$_default = module.exports.default = $6f813d5b1c360eb6$var$PlusSquareIcon;

});

parcelRegister("f1iv3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::da032184393a31024799f85576d6996e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aef54caff2b1870d$var$_react = $aef54caff2b1870d$var$_interopRequireDefault((parcelRequire("cozmU")));

var $aef54caff2b1870d$var$_baseNew = $aef54caff2b1870d$var$_interopRequireDefault((parcelRequire("gElAV")));
function $aef54caff2b1870d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WorkItems".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/work-items
 * Usage guidance:
 * Reserved for representing multiple work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $aef54caff2b1870d$var$WorkItemsIcon = (props)=>/*#__PURE__*/ $aef54caff2b1870d$var$_react.default.createElement($aef54caff2b1870d$var$_baseNew.default, Object.assign({
        name: "WorkItemsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11.5 4a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5zM9.448 5.608l-3.167 3.75a.75.75 0 0 1-1.09.061l-.055-.06-1.584-1.876 1.146-.966 1.01 1.196 2.594-3.071zM13 10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2z"/><path fill="currentcolor" d="M14.5 11.75V7H16v4.75A3.25 3.25 0 0 1 12.75 15H5v-1.5h7.75a1.75 1.75 0 0 0 1.75-1.75"/>`
    }, props));
$aef54caff2b1870d$var$WorkItemsIcon.displayName = 'WorkItemsIcon';
var $aef54caff2b1870d$var$_default = module.exports.default = $aef54caff2b1870d$var$WorkItemsIcon;

});

parcelRegister("6spAz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9d95bc13dae28d7a17136c443b31d134>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4b39350215fac8f3$var$_react = $4b39350215fac8f3$var$_interopRequireDefault((parcelRequire("cozmU")));

var $4b39350215fac8f3$var$_baseNew = $4b39350215fac8f3$var$_interopRequireDefault((parcelRequire("gElAV")));
function $4b39350215fac8f3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Bug".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/bug
 * Usage guidance:
 * Multi purpose - Known uses: Request types in JSM, bugs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4b39350215fac8f3$var$BugIcon = (props)=>/*#__PURE__*/ $4b39350215fac8f3$var$_react.default.createElement($4b39350215fac8f3$var$_baseNew.default, Object.assign({
        name: "BugIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 2.5A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 8 2.5m3 1.52V4a3 3 0 0 0-6 0v.02c-.29.05-.553.182-.761.372l-.887-.633-.917-2.064-1.37.61.944 2.125c.09.204.234.38.416.51l1.325.946V7H.5v1.5h3.25v1.149l-1.15.958a1.25 1.25 0 0 0-.318.401L1.08 13.415l1.342.67 1.18-2.36.46-.383A4.25 4.25 0 0 0 8.001 14h.249A4 4 0 0 0 12 11.393l.4.333 1.18 2.36 1.34-.671-1.202-2.407a1.25 1.25 0 0 0-.318-.401l-1.15-.958V8.5h3.25V7h-3.25V5.886l1.325-.946a1.25 1.25 0 0 0 .416-.51l.944-2.125-1.37-.61-.917 2.064-.887.633A1.5 1.5 0 0 0 11 4.02M10.75 10V5.5h-5.5v4.443l.035.226A2.75 2.75 0 0 0 8 12.5h.249a2.5 2.5 0 0 0 2.5-2.5" clip-rule="evenodd"/>`
    }, props));
$4b39350215fac8f3$var$BugIcon.displayName = 'BugIcon';
var $4b39350215fac8f3$var$_default = module.exports.default = $4b39350215fac8f3$var$BugIcon;

});

parcelRegister("EzOZy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::92d25973bebe527e96d6f3e854e8f605>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $079f85ef5413dfcd$var$_react = $079f85ef5413dfcd$var$_interopRequireDefault((parcelRequire("cozmU")));

var $079f85ef5413dfcd$var$_baseNew = $079f85ef5413dfcd$var$_interopRequireDefault((parcelRequire("gElAV")));
function $079f85ef5413dfcd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Tag".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/tag
 * Usage guidance:
 * Single purpose - Reserved for tags in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $079f85ef5413dfcd$var$TagIcon = (props)=>/*#__PURE__*/ $079f85ef5413dfcd$var$_react.default.createElement($079f85ef5413dfcd$var$_baseNew.default, Object.assign({
        name: "TagIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2"/><path fill="currentcolor" fill-rule="evenodd" d="M9.286 1a3.25 3.25 0 0 0-2.299.952L1.604 7.336a2 2 0 0 0 0 2.828l4.232 4.232a2 2 0 0 0 2.828 0l5.384-5.383A3.25 3.25 0 0 0 15 6.714V3a2 2 0 0 0-2-2zM8.048 3.013A1.75 1.75 0 0 1 9.286 2.5H13a.5.5 0 0 1 .5.5v3.714c0 .465-.184.91-.513 1.238l-5.383 5.384a.5.5 0 0 1-.708 0L2.664 9.104a.5.5 0 0 1 0-.708z" clip-rule="evenodd"/>`
    }, props));
$079f85ef5413dfcd$var$TagIcon.displayName = 'TagIcon';
var $079f85ef5413dfcd$var$_default = module.exports.default = $079f85ef5413dfcd$var$TagIcon;

});

parcelRegister("8VfSP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b5f47220b55c2d3eb4af3287fdd7d034>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $67eff7b836b3a29e$var$_react = $67eff7b836b3a29e$var$_interopRequireDefault((parcelRequire("cozmU")));

var $67eff7b836b3a29e$var$_baseNew = $67eff7b836b3a29e$var$_interopRequireDefault((parcelRequire("gElAV")));
function $67eff7b836b3a29e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "GrowDiagonal".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/grow-diagonal
 * Usage guidance:
 * Single purpose - Reserved for increasing the size of an element when height and width are changed concurrently.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $67eff7b836b3a29e$var$GrowDiagonalIcon = (props)=>/*#__PURE__*/ $67eff7b836b3a29e$var$_react.default.createElement($67eff7b836b3a29e$var$_baseNew.default, Object.assign({
        name: "GrowDiagonalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 2.28 9.53 7.53 8.47 6.47l5.25-5.25zM1.22 13.72l5.25-5.25 1.06 1.06-5.25 5.25z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M9.5 1h4.75a.75.75 0 0 1 .75.75V6.5h-1.5v-4h-4zm-7 12.5v-4H1v4.75c0 .414.336.75.75.75H6.5v-1.5z" clip-rule="evenodd"/>`
    }, props));
$67eff7b836b3a29e$var$GrowDiagonalIcon.displayName = 'GrowDiagonalIcon';
var $67eff7b836b3a29e$var$_default = module.exports.default = $67eff7b836b3a29e$var$GrowDiagonalIcon;

});

parcelRegister("cY2bA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::789b613a7bb3e949907a585f335820cb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $970cc8b2424c50e3$var$_react = $970cc8b2424c50e3$var$_interopRequireDefault((parcelRequire("cozmU")));

var $970cc8b2424c50e3$var$_baseNew = $970cc8b2424c50e3$var$_interopRequireDefault((parcelRequire("gElAV")));
function $970cc8b2424c50e3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CommentAdd".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/comment-add
 * Usage guidance:
 * Single purpose - Reserved for adding a comment to an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $970cc8b2424c50e3$var$CommentAddIcon = (props)=>/*#__PURE__*/ $970cc8b2424c50e3$var$_react.default.createElement($970cc8b2424c50e3$var$_baseNew.default, Object.assign({
        name: "CommentAddIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2zM0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM7.25 6.5V4.25h1.5V6.5H11V8H8.75v2.25h-1.5V8H5V6.5z" clip-rule="evenodd"/>`
    }, props));
$970cc8b2424c50e3$var$CommentAddIcon.displayName = 'CommentAddIcon';
var $970cc8b2424c50e3$var$_default = module.exports.default = $970cc8b2424c50e3$var$CommentAddIcon;

});

parcelRegister("jdueN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::162743b0fcb7aa45244b1ecfef2757e3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $039c3ca430ebc31e$var$_react = $039c3ca430ebc31e$var$_interopRequireDefault((parcelRequire("cozmU")));

var $039c3ca430ebc31e$var$_baseNew = $039c3ca430ebc31e$var$_interopRequireDefault((parcelRequire("gElAV")));
function $039c3ca430ebc31e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StrokeWeightSmall".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/stroke-weight-small
 * Usage guidance:
 * Reserved for representing thin border stroke widths.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $039c3ca430ebc31e$var$StrokeWeightSmallIcon = (props)=>/*#__PURE__*/ $039c3ca430ebc31e$var$_react.default.createElement($039c3ca430ebc31e$var$_baseNew.default, Object.assign({
        name: "StrokeWeightSmallIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.25 8a1.75 1.75 0 1 0 3.5 0 1.75 1.75 0 0 0-3.5 0" clip-rule="evenodd"/>`
    }, props));
$039c3ca430ebc31e$var$StrokeWeightSmallIcon.displayName = 'StrokeWeightSmallIcon';
var $039c3ca430ebc31e$var$_default = module.exports.default = $039c3ca430ebc31e$var$StrokeWeightSmallIcon;

});

parcelRegister("dPtk6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f30c8a0e141bf1e6698e5576aea6cb6a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a116c8c2f94f5b73$var$_react = $a116c8c2f94f5b73$var$_interopRequireDefault((parcelRequire("cozmU")));

var $a116c8c2f94f5b73$var$_baseNew = $a116c8c2f94f5b73$var$_interopRequireDefault((parcelRequire("gElAV")));
function $a116c8c2f94f5b73$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Customize".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/customize
 * Usage guidance:
 * Known uses: customize sidebar, customize view, settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a116c8c2f94f5b73$var$CustomizeIcon = (props)=>/*#__PURE__*/ $a116c8c2f94f5b73$var$_react.default.createElement($a116c8c2f94f5b73$var$_baseNew.default, Object.assign({
        name: "CustomizeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M7.5 10.5V12H0v-1.5zM16 4v1.5H8.5V4zm-5.5 8.75h1v-3h-1zM13 10.5h3V12h-3v.875c0 .76-.616 1.375-1.375 1.375h-1.25c-.76 0-1.375-.616-1.375-1.375v-3.25c0-.76.616-1.375 1.375-1.375h1.25c.76 0 1.375.616 1.375 1.375zM5.5 3.25h-1v3h1zM7 6.375c0 .76-.616 1.375-1.375 1.375h-1.25C3.615 7.75 3 7.134 3 6.375V5.5H0V4h3v-.875c0-.76.616-1.375 1.375-1.375h1.25C6.385 1.75 7 2.366 7 3.125z"/>`
    }, props));
$a116c8c2f94f5b73$var$CustomizeIcon.displayName = 'CustomizeIcon';
var $a116c8c2f94f5b73$var$_default = module.exports.default = $a116c8c2f94f5b73$var$CustomizeIcon;

});

parcelRegister("V3JOP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f4f837bc4fc4ebb0701c77b659a16c91>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0ab83946f72fcd73$var$_react = $0ab83946f72fcd73$var$_interopRequireDefault((parcelRequire("cozmU")));

var $0ab83946f72fcd73$var$_baseNew = $0ab83946f72fcd73$var$_interopRequireDefault((parcelRequire("gElAV")));
function $0ab83946f72fcd73$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LinkExternal".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/link-external
 * Usage guidance:
 * Single purpose - Reserved for links that open up a new tab.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0ab83946f72fcd73$var$LinkExternalIcon = (props)=>/*#__PURE__*/ $0ab83946f72fcd73$var$_react.default.createElement($0ab83946f72fcd73$var$_baseNew.default, Object.assign({
        name: "LinkExternalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-3H15v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h3v1.5zM10 1h4.25a.75.75 0 0 1 .75.75V6h-1.5V3.56L7.53 9.53 6.47 8.47l5.97-5.97H10z" clip-rule="evenodd"/>`
    }, props));
$0ab83946f72fcd73$var$LinkExternalIcon.displayName = 'LinkExternalIcon';
var $0ab83946f72fcd73$var$_default = module.exports.default = $0ab83946f72fcd73$var$LinkExternalIcon;

});

parcelRegister("lbT4j", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0bcc09233c0d8034f215d31089943e8a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f6d5578b7b3fadf6$var$_react = $f6d5578b7b3fadf6$var$_interopRequireDefault((parcelRequire("cozmU")));

var $f6d5578b7b3fadf6$var$_baseNew = $f6d5578b7b3fadf6$var$_interopRequireDefault((parcelRequire("gElAV")));
function $f6d5578b7b3fadf6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StarUnstarred".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/star-unstarred
 * Usage guidance:
 * Single purpose - Reserved for starring or favoriting objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f6d5578b7b3fadf6$var$StarUnstarredIcon = (props)=>/*#__PURE__*/ $f6d5578b7b3fadf6$var$_react.default.createElement($f6d5578b7b3fadf6$var$_baseNew.default, Object.assign({
        name: "StarUnstarredIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a.75.75 0 0 1 .7.48l1.705 4.434 4.403.338a.75.75 0 0 1 .422 1.324l-3.38 2.818 1.25 4.662a.75.75 0 0 1-1.148.813L8 12.159l-3.95 2.71a.75.75 0 0 1-1.15-.813l1.251-4.662L.77 6.576a.75.75 0 0 1 .422-1.324l4.403-.338L7.3.48A.75.75 0 0 1 8 0m0 2.84L6.655 6.335l-3.506.27 2.7 2.25-.973 3.627L8 10.341l3.124 2.142-.973-3.627 2.7-2.25-3.506-.27z" clip-rule="evenodd"/>`
    }, props));
$f6d5578b7b3fadf6$var$StarUnstarredIcon.displayName = 'StarUnstarredIcon';
var $f6d5578b7b3fadf6$var$_default = module.exports.default = $f6d5578b7b3fadf6$var$StarUnstarredIcon;

});

parcelRegister("hjuSl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::08bea97e6ef859bddfe6e560c64139ac>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c9ac294210df3e6a$var$_react = $c9ac294210df3e6a$var$_interopRequireDefault((parcelRequire("cozmU")));

var $c9ac294210df3e6a$var$_baseNew = $c9ac294210df3e6a$var$_interopRequireDefault((parcelRequire("gElAV")));
function $c9ac294210df3e6a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Microphone".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/microphone
 * Usage guidance:
 * Multi purpose - Known uses: record sounds in Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c9ac294210df3e6a$var$MicrophoneIcon = (props)=>/*#__PURE__*/ $c9ac294210df3e6a$var$_react.default.createElement($c9ac294210df3e6a$var$_baseNew.default, Object.assign({
        name: "MicrophoneIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A1.5 1.5 0 0 0 6.5 3v4a1.5 1.5 0 1 0 3 0V3A1.5 1.5 0 0 0 8 1.5M5 3a3 3 0 0 1 6 0v4a3 3 0 0 1-6 0zM3.5 7a4.5 4.5 0 0 0 9 0H14c0 3.06-2.29 5.585-5.25 5.954V14.5H12V16H4v-1.5h3.25v-1.546A6 6 0 0 1 2 7z" clip-rule="evenodd"/>`
    }, props));
$c9ac294210df3e6a$var$MicrophoneIcon.displayName = 'MicrophoneIcon';
var $c9ac294210df3e6a$var$_default = module.exports.default = $c9ac294210df3e6a$var$MicrophoneIcon;

});

parcelRegister("2x0Nk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b0528a626c1387948393212361213808>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1d7f47a01b3bcb2c$var$_react = $1d7f47a01b3bcb2c$var$_interopRequireDefault((parcelRequire("cozmU")));

var $1d7f47a01b3bcb2c$var$_baseNew = $1d7f47a01b3bcb2c$var$_interopRequireDefault((parcelRequire("gElAV")));
function $1d7f47a01b3bcb2c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FullscreenEnter".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/fullscreen-enter
 * Usage guidance:
 * Single purpose - Reserved for full screen videos or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1d7f47a01b3bcb2c$var$FullscreenEnterIcon = (props)=>/*#__PURE__*/ $1d7f47a01b3bcb2c$var$_react.default.createElement($1d7f47a01b3bcb2c$var$_baseNew.default, Object.assign({
        name: "FullscreenEnterIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13 2.5h-3V1h3a2 2 0 0 1 2 2v3h-1.5V3a.5.5 0 0 0-.5-.5m-10 0a.5.5 0 0 0-.5.5v3H1V3a2 2 0 0 1 2-2h3v1.5zM2.5 10v3a.5.5 0 0 0 .5.5h3V15H3a2 2 0 0 1-2-2v-3zm11 3v-3H15v3a2 2 0 0 1-2 2h-3v-1.5h3a.5.5 0 0 0 .5-.5" clip-rule="evenodd"/>`
    }, props));
$1d7f47a01b3bcb2c$var$FullscreenEnterIcon.displayName = 'FullscreenEnterIcon';
var $1d7f47a01b3bcb2c$var$_default = module.exports.default = $1d7f47a01b3bcb2c$var$FullscreenEnterIcon;

});

parcelRegister("fZ6J4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3ebe5ff20cdf87792f4002924f826d6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ba31c52b3caf461a$var$_react = $ba31c52b3caf461a$var$_interopRequireDefault((parcelRequire("cozmU")));

var $ba31c52b3caf461a$var$_baseNew = $ba31c52b3caf461a$var$_interopRequireDefault((parcelRequire("gElAV")));
function $ba31c52b3caf461a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoPlay".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/video-play
 * Usage guidance:
 * Single purpose - Reserved for play video in Media.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ba31c52b3caf461a$var$VideoPlayIcon = (props)=>/*#__PURE__*/ $ba31c52b3caf461a$var$_react.default.createElement($ba31c52b3caf461a$var$_baseNew.default, Object.assign({
        name: "VideoPlayIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.112C2 1.592 3.63.627 4.963 1.36l8.902 4.888c1.383.76 1.383 2.747 0 3.506l-8.902 4.888C3.63 15.373 2 14.408 2 12.888zm2.24-.438a.5.5 0 0 0-.74.438v9.776a.5.5 0 0 0 .74.438l8.903-4.888a.5.5 0 0 0 0-.876z" clip-rule="evenodd"/>`
    }, props));
$ba31c52b3caf461a$var$VideoPlayIcon.displayName = 'VideoPlayIcon';
var $ba31c52b3caf461a$var$_default = module.exports.default = $ba31c52b3caf461a$var$VideoPlayIcon;

});

parcelRegister("fHs3z", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::14bdce01d37a11560d25cb9029d3aa79>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b6e0a2a4008a4d91$var$_react = $b6e0a2a4008a4d91$var$_interopRequireDefault((parcelRequire("cozmU")));

var $b6e0a2a4008a4d91$var$_baseNew = $b6e0a2a4008a4d91$var$_interopRequireDefault((parcelRequire("gElAV")));
function $b6e0a2a4008a4d91$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Copy".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/copy
 * Usage guidance:
 * Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b6e0a2a4008a4d91$var$CopyIcon = (props)=>/*#__PURE__*/ $b6e0a2a4008a4d91$var$_react.default.createElement($b6e0a2a4008a4d91$var$_baseNew.default, Object.assign({
        name: "CopyIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM16 6v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75V6z" clip-rule="evenodd"/>`
    }, props));
$b6e0a2a4008a4d91$var$CopyIcon.displayName = 'CopyIcon';
var $b6e0a2a4008a4d91$var$_default = module.exports.default = $b6e0a2a4008a4d91$var$CopyIcon;

});

parcelRegister("ijkxh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3bc23dd2dda71d7961123faeb4e223f6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d549ee5876e0bf5c$var$_react = $d549ee5876e0bf5c$var$_interopRequireDefault((parcelRequire("cozmU")));

var $d549ee5876e0bf5c$var$_baseNew = $d549ee5876e0bf5c$var$_interopRequireDefault((parcelRequire("gElAV")));
function $d549ee5876e0bf5c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Roadmap".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/roadmap
 * Usage guidance:
 * Single purpose - Reserved for roadmaps in Jira or Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d549ee5876e0bf5c$var$RoadmapIcon = (props)=>/*#__PURE__*/ $d549ee5876e0bf5c$var$_react.default.createElement($d549ee5876e0bf5c$var$_baseNew.default, Object.assign({
        name: "RoadmapIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM3 11a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$d549ee5876e0bf5c$var$RoadmapIcon.displayName = 'RoadmapIcon';
var $d549ee5876e0bf5c$var$_default = module.exports.default = $d549ee5876e0bf5c$var$RoadmapIcon;

});

parcelRegister("4HbMh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::da5ebd956805027d47c76334c5311def>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $36b4505fa269fc95$var$_react = $36b4505fa269fc95$var$_interopRequireDefault((parcelRequire("cozmU")));

var $36b4505fa269fc95$var$_baseNew = $36b4505fa269fc95$var$_interopRequireDefault((parcelRequire("gElAV")));
function $36b4505fa269fc95$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Screen".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/screen
 * Usage guidance:
 * Multi purpose - Known uses: assets in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $36b4505fa269fc95$var$ScreenIcon = (props)=>/*#__PURE__*/ $36b4505fa269fc95$var$_react.default.createElement($36b4505fa269fc95$var$_baseNew.default, Object.assign({
        name: "ScreenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H8.75v1.5H12V15H4v-1.5h3.25V12H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$36b4505fa269fc95$var$ScreenIcon.displayName = 'ScreenIcon';
var $36b4505fa269fc95$var$_default = module.exports.default = $36b4505fa269fc95$var$ScreenIcon;

});

parcelRegister("dCk1A", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::96d42dfb62ccf629ef23fd867e155b78>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9e9e5b6d54ddbd5e$var$_react = $9e9e5b6d54ddbd5e$var$_interopRequireDefault((parcelRequire("cozmU")));

var $9e9e5b6d54ddbd5e$var$_baseNew = $9e9e5b6d54ddbd5e$var$_interopRequireDefault((parcelRequire("gElAV")));
function $9e9e5b6d54ddbd5e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Accessibility".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/accessibility
 * Usage guidance:
 * Reserved for representing accessibility and accessibility-related features and settings
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9e9e5b6d54ddbd5e$var$AccessibilityIcon = (props)=>/*#__PURE__*/ $9e9e5b6d54ddbd5e$var$_react.default.createElement($9e9e5b6d54ddbd5e$var$_baseNew.default, Object.assign({
        name: "AccessibilityIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 2.5A.75.75 0 1 0 8 4a.75.75 0 0 0 0-1.5m-2.25.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0M6.77 8H2V6.5h12V8H9.23l3.18 6.16-1.33.69L8 8.88l-3.08 5.96-1.33-.69z" clip-rule="evenodd"/>`
    }, props));
$9e9e5b6d54ddbd5e$var$AccessibilityIcon.displayName = 'AccessibilityIcon';
var $9e9e5b6d54ddbd5e$var$_default = module.exports.default = $9e9e5b6d54ddbd5e$var$AccessibilityIcon;

});

parcelRegister("mfdwv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1bef6fed7a8c303759ea85061e386dfa>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $042ddbfdada9c1f0$var$_react = $042ddbfdada9c1f0$var$_interopRequireDefault((parcelRequire("cozmU")));

var $042ddbfdada9c1f0$var$_baseNew = $042ddbfdada9c1f0$var$_interopRequireDefault((parcelRequire("gElAV")));
function $042ddbfdada9c1f0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiChat".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/ai-chat
 * Usage guidance:
 * Reserved for white label Rovo experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $042ddbfdada9c1f0$var$AiChatIcon = (props)=>/*#__PURE__*/ $042ddbfdada9c1f0$var$_react.default.createElement($042ddbfdada9c1f0$var$_baseNew.default, Object.assign({
        name: "AiChatIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 3.125C14.5 2.504 13.996 2 13.375 2H2.625C2.004 2 1.5 2.504 1.5 3.125v10.832L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125zm1.5 8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25V3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125z"/><path fill="currentcolor" d="M5 6.25a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/>`
    }, props));
$042ddbfdada9c1f0$var$AiChatIcon.displayName = 'AiChatIcon';
var $042ddbfdada9c1f0$var$_default = module.exports.default = $042ddbfdada9c1f0$var$AiChatIcon;

});

parcelRegister("320o0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::63b67c15f5ce4acfe8885b27c8fde116>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2351dbb66f88eeda$var$_react = $2351dbb66f88eeda$var$_interopRequireDefault((parcelRequire("cozmU")));

var $2351dbb66f88eeda$var$_baseNew = $2351dbb66f88eeda$var$_interopRequireDefault((parcelRequire("gElAV")));
function $2351dbb66f88eeda$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AtlassianIntelligence".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/atlassian-intelligence
 * Usage guidance:
 * Single purpose - Reserved for Atlassian Intelligence apps or experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2351dbb66f88eeda$var$AtlassianIntelligenceIcon = (props)=>/*#__PURE__*/ $2351dbb66f88eeda$var$_react.default.createElement($2351dbb66f88eeda$var$_baseNew.default, Object.assign({
        name: "AtlassianIntelligenceIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M8.75 12v3h-1.5v-3zm-2.22-1.47-4 4-1.06-1.06 4-4zm8 2.94-1.06 1.06-4-4 1.06-1.06zM4 7.25v1.5H1v-1.5zm11 0v1.5h-3v-1.5zM6.53 5.47 5.47 6.53l-4-4 1.06-1.06zm8-2.94-4 4-1.06-1.06 4-4zM8.75 1v3h-1.5V1z"/>`
    }, props));
$2351dbb66f88eeda$var$AtlassianIntelligenceIcon.displayName = 'AtlassianIntelligenceIcon';
var $2351dbb66f88eeda$var$_default = module.exports.default = $2351dbb66f88eeda$var$AtlassianIntelligenceIcon;

});

parcelRegister("lRXxm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6fa3fb0046b3e342809c7777e253d803>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $febcbb04c2d98686$var$_react = $febcbb04c2d98686$var$_interopRequireDefault((parcelRequire("cozmU")));

var $febcbb04c2d98686$var$_baseNew = $febcbb04c2d98686$var$_interopRequireDefault((parcelRequire("gElAV")));
function $febcbb04c2d98686$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Border".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/border
 * Usage guidance:
 * Reserved for toggling the visibility of a border on an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $febcbb04c2d98686$var$BorderIcon = (props)=>/*#__PURE__*/ $febcbb04c2d98686$var$_react.default.createElement($febcbb04c2d98686$var$_baseNew.default, Object.assign({
        name: "BorderIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M8.75 8a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M5.5 8A.75.75 0 1 1 4 8a.75.75 0 0 1 1.5 0M12 8a.75.75 0 1 1-1.5 0A.75.75 0 0 1 12 8m-3.25 3.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m0-6.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"/><path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$febcbb04c2d98686$var$BorderIcon.displayName = 'BorderIcon';
var $febcbb04c2d98686$var$_default = module.exports.default = $febcbb04c2d98686$var$BorderIcon;

});

parcelRegister("eFBG8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::19789dd5cbb6357b0ccbe57e83e1f02a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aae21f36646c7df4$var$_react = $aae21f36646c7df4$var$_interopRequireDefault((parcelRequire("cozmU")));

var $aae21f36646c7df4$var$_baseNew = $aae21f36646c7df4$var$_interopRequireDefault((parcelRequire("gElAV")));
function $aae21f36646c7df4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "DataFlow".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/data-flow
 * Usage guidance:
 * Known usages: Database schema in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $aae21f36646c7df4$var$DataFlowIcon = (props)=>/*#__PURE__*/ $aae21f36646c7df4$var$_react.default.createElement($aae21f36646c7df4$var$_baseNew.default, Object.assign({
        name: "DataFlowIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 13.75a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0m0-5.75A.75.75 0 1 0 13 8a.75.75 0 0 0 1.5 0m-13 0A.75.75 0 1 0 3 8a.75.75 0 0 0-1.5 0m13-5.75a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0m1.5 0a2.25 2.25 0 0 1-4.37.75H9.563C8.977 3 8.5 3.476 8.5 4.063V7.25h3.13A2.248 2.248 0 0 1 16 8a2.25 2.25 0 0 1-4.37.75H8.5v3.188c0 .586.476 1.062 1.063 1.062h2.068a2.248 2.248 0 0 1 4.369.75 2.25 2.25 0 0 1-4.37.75H9.563A2.563 2.563 0 0 1 7 11.938V8.75H4.37A2.248 2.248 0 0 1 0 8a2.25 2.25 0 0 1 4.37-.75H7V4.063A2.56 2.56 0 0 1 9.563 1.5h2.068A2.248 2.248 0 0 1 16 2.25"/>`
    }, props));
$aae21f36646c7df4$var$DataFlowIcon.displayName = 'DataFlowIcon';
var $aae21f36646c7df4$var$_default = module.exports.default = $aae21f36646c7df4$var$DataFlowIcon;

});

parcelRegister("2lF67", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0e04d9c1f71726070cc58d5e51262548>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1b5d6c1b76929e0c$var$_react = $1b5d6c1b76929e0c$var$_interopRequireDefault((parcelRequire("cozmU")));

var $1b5d6c1b76929e0c$var$_baseNew = $1b5d6c1b76929e0c$var$_interopRequireDefault((parcelRequire("gElAV")));
function $1b5d6c1b76929e0c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "DataString".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/data-string
 * Usage guidance:
 * Known uses: Representing string datatype fields in Proforma and databases.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1b5d6c1b76929e0c$var$DataStringIcon = (props)=>/*#__PURE__*/ $1b5d6c1b76929e0c$var$_react.default.createElement($1b5d6c1b76929e0c$var$_baseNew.default, Object.assign({
        name: "DataStringIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 6a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v6H3.5V9.5h-2V12H0zm1.5 2h2V6a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5zM6 8a.75.75 0 0 1 .75-.75H9a2 2 0 0 1 2 2V10a2 2 0 0 1-2 2H6.75a.75.75 0 0 1-.75-.75zm1.5.75v1.75H9a.5.5 0 0 0 .5-.5v-.75a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M6 4.75A.75.75 0 0 1 6.75 4H9a2 2 0 0 1 2 2v.75a2 2 0 0 1-2 2H6.75A.75.75 0 0 1 6 8zm1.5.75v1.75H9a.5.5 0 0 0 .5-.5V6a.5.5 0 0 0-.5-.5zM12 6a2 2 0 0 1 2-2h2v1.5h-2a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h2V12h-2a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$1b5d6c1b76929e0c$var$DataStringIcon.displayName = 'DataStringIcon';
var $1b5d6c1b76929e0c$var$_default = module.exports.default = $1b5d6c1b76929e0c$var$DataStringIcon;

});

parcelRegister("lBKFk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::03a78db56667d91426ba6b99862fb3a6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fbb140801a59f688$var$_react = $fbb140801a59f688$var$_interopRequireDefault((parcelRequire("cozmU")));

var $fbb140801a59f688$var$_baseNew = $fbb140801a59f688$var$_interopRequireDefault((parcelRequire("gElAV")));
function $fbb140801a59f688$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Database".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/database
 * Usage guidance:
 * Single purpose - Reserved for databases in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fbb140801a59f688$var$DatabaseIcon = (props)=>/*#__PURE__*/ $fbb140801a59f688$var$_react.default.createElement($fbb140801a59f688$var$_baseNew.default, Object.assign({
        name: "DatabaseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v3.5h11V3a.5.5 0 0 0-.5-.5zM13.5 8H8.75v2h4.75zm0 3.5H8.75v2H13a.5.5 0 0 0 .5-.5zm-6.25 2v-2H2.5V13a.5.5 0 0 0 .5.5zM2.5 10h4.75V8H2.5z" clip-rule="evenodd"/>`
    }, props));
$fbb140801a59f688$var$DatabaseIcon.displayName = 'DatabaseIcon';
var $fbb140801a59f688$var$_default = module.exports.default = $fbb140801a59f688$var$DatabaseIcon;

});

parcelRegister("BeiRH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8c3029cc07a85b19c00df4d8661271a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $06fe8d261dfa6396$var$_react = $06fe8d261dfa6396$var$_interopRequireDefault((parcelRequire("cozmU")));

var $06fe8d261dfa6396$var$_baseNew = $06fe8d261dfa6396$var$_interopRequireDefault((parcelRequire("gElAV")));
function $06fe8d261dfa6396$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EmojiNeutral".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/emoji-neutral
 * Usage guidance:
 * Reserved for representing a neutral tone or sentiment.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $06fe8d261dfa6396$var$EmojiNeutralIcon = (props)=>/*#__PURE__*/ $06fe8d261dfa6396$var$_react.default.createElement($06fe8d261dfa6396$var$_baseNew.default, Object.assign({
        name: "EmojiNeutralIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m4.5-1.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m4.5 0a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m2.25 3.25V11h-6.5V9.5z" clip-rule="evenodd"/>`
    }, props));
$06fe8d261dfa6396$var$EmojiNeutralIcon.displayName = 'EmojiNeutralIcon';
var $06fe8d261dfa6396$var$_default = module.exports.default = $06fe8d261dfa6396$var$EmojiNeutralIcon;

});

parcelRegister("bAlk9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ada0fe608fa318c2badf0fa9f1c1afc7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $86f3990467c8eed5$var$_react = $86f3990467c8eed5$var$_interopRequireDefault((parcelRequire("cozmU")));

var $86f3990467c8eed5$var$_baseNew = $86f3990467c8eed5$var$_interopRequireDefault((parcelRequire("gElAV")));
function $86f3990467c8eed5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EmojiRemove".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/emoji-remove
 * Usage guidance:
 * Reserved for removing emoji.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $86f3990467c8eed5$var$EmojiRemoveIcon = (props)=>/*#__PURE__*/ $86f3990467c8eed5$var$_react.default.createElement($86f3990467c8eed5$var$_baseNew.default, Object.assign({
        name: "EmojiRemoveIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m10.72 13.9 1.12 1.12A8 8 0 0 1 .98 4.16L2.1 5.28a6.5 6.5 0 0 0 8.63 8.63M8 0C6.61 0 5.3.36 4.16.98L5.28 2.1a6.5 6.5 0 0 1 8.63 8.63l1.12 1.12A8 8 0 0 0 8 0"/><path fill="currentcolor" d="m9.06 5.88 1.57 1.57a1.25 1.25 0 1 0-1.57-1.57m-2.97 4.15c.38.3.87.57 1.44.67l1.43 1.43c-.3.07-.62.11-.96.11-1.23 0-2.2-.54-2.83-1.03a6 6 0 0 1-.94-.92l-.06-.07-.02-.02-.01-.01.61-.44.61-.44.01.01.03.04q.05.06.14.16c.13.14.31.33.55.51M.47 1.53l14 14 1.06-1.06-14-14z"/>`
    }, props));
$86f3990467c8eed5$var$EmojiRemoveIcon.displayName = 'EmojiRemoveIcon';
var $86f3990467c8eed5$var$_default = module.exports.default = $86f3990467c8eed5$var$EmojiRemoveIcon;

});

parcelRegister("7vAVv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::30b67768e793efc137c547d41e4494f8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $57781280e56f59c7$var$_react = $57781280e56f59c7$var$_interopRequireDefault((parcelRequire("cozmU")));

var $57781280e56f59c7$var$_baseNew = $57781280e56f59c7$var$_interopRequireDefault((parcelRequire("gElAV")));
function $57781280e56f59c7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Epic".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/epic
 * Usage guidance:
 * Single purpose - Reserved for epics in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $57781280e56f59c7$var$EpicIcon = (props)=>/*#__PURE__*/ $57781280e56f59c7$var$_react.default.createElement($57781280e56f59c7$var$_baseNew.default, Object.assign({
        name: "EpicIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.271.05a.75.75 0 0 1 .479.7v4.635l3.147.63a.75.75 0 0 1 .407 1.24l-7.75 8.5a.75.75 0 0 1-1.304-.505v-4.635l-3.147-.63a.75.75 0 0 1-.407-1.24l7.75-8.5A.75.75 0 0 1 10.27.05M3.698 8.776l3.052.61v3.93l5.552-6.09-3.052-.61v-3.93z" clip-rule="evenodd"/>`
    }, props));
$57781280e56f59c7$var$EpicIcon.displayName = 'EpicIcon';
var $57781280e56f59c7$var$_default = module.exports.default = $57781280e56f59c7$var$EpicIcon;

});

parcelRegister("d7K3t", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f980aa850a765b817eeee03433658425>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $98dfa760b0d86986$var$_react = $98dfa760b0d86986$var$_interopRequireDefault((parcelRequire("cozmU")));

var $98dfa760b0d86986$var$_baseNew = $98dfa760b0d86986$var$_interopRequireDefault((parcelRequire("gElAV")));
function $98dfa760b0d86986$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FieldCheckboxGroup".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/field-checkbox-group
 * Usage guidance:
 * Known uses: Checkbox group field type in Proforma.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $98dfa760b0d86986$var$FieldCheckboxGroupIcon = (props)=>/*#__PURE__*/ $98dfa760b0d86986$var$_react.default.createElement($98dfa760b0d86986$var$_baseNew.default, Object.assign({
        name: "FieldCheckboxGroupIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 2.75A.75.75 0 0 1 1.75 2h3.5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-3.5A.75.75 0 0 1 1 6.25zm1.5.75v2h2v-2zM16 5.25H8v-1.5h8zM1 9.75A.75.75 0 0 1 1.75 9h3.5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75zm1.5.75v2h2v-2zM16 12.25H8v-1.5h8z" clip-rule="evenodd"/>`
    }, props));
$98dfa760b0d86986$var$FieldCheckboxGroupIcon.displayName = 'FieldCheckboxGroupIcon';
var $98dfa760b0d86986$var$_default = module.exports.default = $98dfa760b0d86986$var$FieldCheckboxGroupIcon;

});

parcelRegister("7A1BE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::74510fa05808e33e81f85bcea0e54cb9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $584d242b1114c506$var$_react = $584d242b1114c506$var$_interopRequireDefault((parcelRequire("cozmU")));

var $584d242b1114c506$var$_baseNew = $584d242b1114c506$var$_interopRequireDefault((parcelRequire("gElAV")));
function $584d242b1114c506$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FolderOpen".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/folder-open
 * Usage guidance:
 * Single purpose - Reserved for open folders in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $584d242b1114c506$var$FolderOpenIcon = (props)=>/*#__PURE__*/ $584d242b1114c506$var$_react.default.createElement($584d242b1114c506$var$_baseNew.default, Object.assign({
        name: "FolderOpenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.5a.5.5 0 0 0-.5.5v9.473L3.148 6.98c.174-.582.71-.98 1.317-.98H12.5V4.75a.5.5 0 0 0-.5-.5H6.69L4.94 2.5zM14 6h.66c.921 0 1.582.888 1.317 1.77l-1.741 5.805A2 2 0 0 1 12.32 15H1.75A1.75 1.75 0 0 1 0 13.25V3a2 2 0 0 1 2-2h3.56l1.75 1.75H12a2 2 0 0 1 2 2zM2.758 13.5h9.562a.5.5 0 0 0 .479-.356L14.492 7.5H4.558z" clip-rule="evenodd"/>`
    }, props));
$584d242b1114c506$var$FolderOpenIcon.displayName = 'FolderOpenIcon';
var $584d242b1114c506$var$_default = module.exports.default = $584d242b1114c506$var$FolderOpenIcon;

});

parcelRegister("k9qmp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b23362d661b1d96937e16111df60b38e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eab91888d69cd275$var$_react = $eab91888d69cd275$var$_interopRequireDefault((parcelRequire("cozmU")));

var $eab91888d69cd275$var$_baseNew = $eab91888d69cd275$var$_interopRequireDefault((parcelRequire("gElAV")));
function $eab91888d69cd275$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Glasses".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/glasses
 * Usage guidance:
 * Known uses: Changing tone of written content to Educational with Atlassian Intelligence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eab91888d69cd275$var$GlassesIcon = (props)=>/*#__PURE__*/ $eab91888d69cd275$var$_react.default.createElement($eab91888d69cd275$var$_baseNew.default, Object.assign({
        name: "GlassesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.81 2.433-1.804.82c-.353.16-.599.491-.65.876l-.433 3.245A3.5 3.5 0 0 1 3.5 7c1.184 0 2.23.587 2.863 1.486A3 3 0 0 1 8 8c.604 0 1.167.179 1.637.486A3.5 3.5 0 0 1 12.5 7c.567 0 1.103.135 1.577.374l-.433-3.245a1.13 1.13 0 0 0-.65-.876l-1.804-.82.62-1.366 1.805.82A2.63 2.63 0 0 1 15.13 3.93l.76 5.697A3.505 3.505 0 0 1 12.5 14a3.5 3.5 0 0 1-3.453-4.074A1.5 1.5 0 0 0 8 9.5c-.407 0-.776.162-1.047.426q.046.281.047.574a3.5 3.5 0 1 1-6.89-.873L.87 3.93a2.63 2.63 0 0 1 1.515-2.042l1.805-.82zM1.5 10.546a2 2 0 1 0 .083-.617zm12.917-.617.082.617a2 2 0 1 1-.082-.617" clip-rule="evenodd"/>`
    }, props));
$eab91888d69cd275$var$GlassesIcon.displayName = 'GlassesIcon';
var $eab91888d69cd275$var$_default = module.exports.default = $eab91888d69cd275$var$GlassesIcon;

});

parcelRegister("4ESzI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0cdb43c090e89be1f8c2155133950489>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $36453b4f25889a92$var$_react = $36453b4f25889a92$var$_interopRequireDefault((parcelRequire("cozmU")));

var $36453b4f25889a92$var$_baseNew = $36453b4f25889a92$var$_interopRequireDefault((parcelRequire("gElAV")));
function $36453b4f25889a92$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "GrowVertical".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/grow-vertical
 * Usage guidance:
 * Single purpose - Reserved for increasing the height of an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $36453b4f25889a92$var$GrowVerticalIcon = (props)=>/*#__PURE__*/ $36453b4f25889a92$var$_react.default.createElement($36453b4f25889a92$var$_baseNew.default, Object.assign({
        name: "GrowVerticalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m7.47 15.78-3.5-3.5 1.06-1.06 2.22 2.22V9h1.5v4.44l2.22-2.22 1.06 1.06-3.5 3.5a.75.75 0 0 1-1.06 0M7.25 2.56 5.03 4.78 3.97 3.72l3.5-3.5a.75.75 0 0 1 1.06 0l3.5 3.5-1.06 1.06-2.22-2.22V7h-1.5z" clip-rule="evenodd"/>`
    }, props));
$36453b4f25889a92$var$GrowVerticalIcon.displayName = 'GrowVerticalIcon';
var $36453b4f25889a92$var$_default = module.exports.default = $36453b4f25889a92$var$GrowVerticalIcon;

});

parcelRegister("a1ZzW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::698cdbb7157fae3127e51e636cf7a8d4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $74d9c3a4fad60229$var$_react = $74d9c3a4fad60229$var$_interopRequireDefault((parcelRequire("cozmU")));

var $74d9c3a4fad60229$var$_baseNew = $74d9c3a4fad60229$var$_interopRequireDefault((parcelRequire("gElAV")));
function $74d9c3a4fad60229$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "InformationCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/information-circle
 * Usage guidance:
 * Known uses: For highlighting information when less visual emphasis is needed within the UI compared to the filled information status icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $74d9c3a4fad60229$var$InformationCircleIcon = (props)=>/*#__PURE__*/ $74d9c3a4fad60229$var$_react.default.createElement($74d9c3a4fad60229$var$_baseNew.default, Object.assign({
        name: "InformationCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.25.25H6.5v-1.5H8a.75.75 0 0 1 .75.75v5h-1.5z" clip-rule="evenodd"/><path fill="currentcolor" d="M9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$74d9c3a4fad60229$var$InformationCircleIcon.displayName = 'InformationCircleIcon';
var $74d9c3a4fad60229$var$_default = module.exports.default = $74d9c3a4fad60229$var$InformationCircleIcon;

});

parcelRegister("2jY8x", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6fe2d9830c0de88aca7b15d9ae153116>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1b0c00ffb76a168d$var$_react = $1b0c00ffb76a168d$var$_interopRequireDefault((parcelRequire("cozmU")));

var $1b0c00ffb76a168d$var$_baseNew = $1b0c00ffb76a168d$var$_interopRequireDefault((parcelRequire("gElAV")));
function $1b0c00ffb76a168d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Markdown".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/markdown
 * Usage guidance:
 * Reserved for representing the Markdown markup language.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1b0c00ffb76a168d$var$MarkdownIcon = (props)=>/*#__PURE__*/ $1b0c00ffb76a168d$var$_react.default.createElement($1b0c00ffb76a168d$var$_baseNew.default, Object.assign({
        name: "MarkdownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1.25 3.5c.293 0 .56.17.682.438L4 8.45l2.068-4.512.052-.096a.75.75 0 0 1 .63-.342h.5a.75.75 0 0 1 .75.75v8.25H6.5V6.595l-1.818 3.968a.75.75 0 0 1-1.364 0L1.5 6.595V12.5H0V4.25a.75.75 0 0 1 .75-.75zM13 3.5v6.111l1.664-2.08 1.172.938-3 3.75a.75.75 0 0 1-1.172 0l-3-3.75 1.172-.938 1.664 2.08V3.5z"/>`
    }, props));
$1b0c00ffb76a168d$var$MarkdownIcon.displayName = 'MarkdownIcon';
var $1b0c00ffb76a168d$var$_default = module.exports.default = $1b0c00ffb76a168d$var$MarkdownIcon;

});

parcelRegister("in5dT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8a8605203ee186b88219a90226cd68d6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d5fe6d2deeadfd3b$var$_react = $d5fe6d2deeadfd3b$var$_interopRequireDefault((parcelRequire("cozmU")));

var $d5fe6d2deeadfd3b$var$_baseNew = $d5fe6d2deeadfd3b$var$_interopRequireDefault((parcelRequire("gElAV")));
function $d5fe6d2deeadfd3b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "MergeFailure".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/merge-failure
 * Usage guidance:
 * Single purpose - Reserved for branches in Bitbucket and Jira that have failed to merge.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d5fe6d2deeadfd3b$var$MergeFailureIcon = (props)=>/*#__PURE__*/ $d5fe6d2deeadfd3b$var$_react.default.createElement($d5fe6d2deeadfd3b$var$_baseNew.default, Object.assign({
        name: "MergeFailureIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3.19 3.25 1.47 1.53 2.53.47l1.72 1.72L5.97.47l1.06 1.06-1.72 1.72 1.72 1.72-1.06 1.06-1.72-1.72-1.72 1.72-1.06-1.06zM8.5 2.5h1.25a2.75 2.75 0 0 1 2.75 2.75v5.378a2.251 2.251 0 1 1-1.5 0V5.25C11 4.56 10.44 4 9.75 4H8.5zm-5 8.128V7.5H5v3.128a2.251 2.251 0 1 1-1.5 0M4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m7.5 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$d5fe6d2deeadfd3b$var$MergeFailureIcon.displayName = 'MergeFailureIcon';
var $d5fe6d2deeadfd3b$var$_default = module.exports.default = $d5fe6d2deeadfd3b$var$MergeFailureIcon;

});

parcelRegister("iUgig", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9a4b0ed0caefc7274bf0dc053ab65673>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dc3a18845fd958fb$var$_react = $dc3a18845fd958fb$var$_interopRequireDefault((parcelRequire("cozmU")));

var $dc3a18845fd958fb$var$_baseNew = $dc3a18845fd958fb$var$_interopRequireDefault((parcelRequire("gElAV")));
function $dc3a18845fd958fb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Note".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/note
 * Usage guidance:
 * Single purpose - Reserved for notes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dc3a18845fd958fb$var$NoteIcon = (props)=>/*#__PURE__*/ $dc3a18845fd958fb$var$_react.default.createElement($dc3a18845fd958fb$var$_baseNew.default, Object.assign({
        name: "NoteIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6.75c0 .52-.206 1.017-.573 1.384l-3.293 3.293A1.96 1.96 0 0 1 9.75 15H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h6V9.75A.75.75 0 0 1 9.75 9h3.75V3a.5.5 0 0 0-.5-.5zm9.94 8H10.5v2.44zM11 6H4V4.5h7zM7 9.5H4V8h3z" clip-rule="evenodd"/>`
    }, props));
$dc3a18845fd958fb$var$NoteIcon.displayName = 'NoteIcon';
var $dc3a18845fd958fb$var$_default = module.exports.default = $dc3a18845fd958fb$var$NoteIcon;

});

parcelRegister("5P5VV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9f072c91e6fc84e9e2a980f0d5982a44>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $43d6516b371c6ea6$var$_react = $43d6516b371c6ea6$var$_interopRequireDefault((parcelRequire("cozmU")));

var $43d6516b371c6ea6$var$_baseNew = $43d6516b371c6ea6$var$_interopRequireDefault((parcelRequire("gElAV")));
function $43d6516b371c6ea6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PinFilled".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/pin-filled
 * Usage guidance:
 * Known uses: pinned fields.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $43d6516b371c6ea6$var$PinFilledIcon = (props)=>/*#__PURE__*/ $43d6516b371c6ea6$var$_react.default.createElement($43d6516b371c6ea6$var$_baseNew.default, Object.assign({
        name: "PinFilledIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.354 0a1.376 1.376 0 0 0-1.268 1.908l.089.174L5 3.458v3.475a5 5 0 0 0-1.184.61C2.898 8.195 2 9.348 2 11.25c0 .414.336.75.75.75h4.5v4h1.5v-4h4.5a.75.75 0 0 0 .75-.75c0-1.903-.898-3.056-1.816-3.706A5 5 0 0 0 11 6.933V3.458l.825-1.376A1.375 1.375 0 0 0 10.647 0zm4.252 2.864-.045.09a.8.8 0 0 0-.061.296V7.5c0 .367.265.68.627.74l.008.001.066.016a3.4 3.4 0 0 1 1.115.512c.463.327.938.852 1.113 1.731H3.57c.175-.88.65-1.404 1.113-1.731a3.4 3.4 0 0 1 1.181-.528l.008-.002A.75.75 0 0 0 6.5 7.5V3.25a.75.75 0 0 0-.106-.386L5.574 1.5h4.852z"/><path fill="currentcolor" d="m9.606 2.864-.045.09a.8.8 0 0 0-.061.296V7.5c0 .367.265.68.627.74l.008.001.066.016a3.4 3.4 0 0 1 1.115.512c.463.327.938.852 1.113 1.731H3.57c.175-.88.65-1.404 1.113-1.731a3.4 3.4 0 0 1 1.181-.528l.008-.002A.75.75 0 0 0 6.5 7.5V3.25a.75.75 0 0 0-.106-.386L5.574 1.5h4.852z"/>`
    }, props));
$43d6516b371c6ea6$var$PinFilledIcon.displayName = 'PinFilledIcon';
var $43d6516b371c6ea6$var$_default = module.exports.default = $43d6516b371c6ea6$var$PinFilledIcon;

});

parcelRegister("9kAZ6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::424ce79cbb2369bd07d56ed8f48d060e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6cb2aba8e68b4af0$var$_react = $6cb2aba8e68b4af0$var$_interopRequireDefault((parcelRequire("cozmU")));

var $6cb2aba8e68b4af0$var$_baseNew = $6cb2aba8e68b4af0$var$_interopRequireDefault((parcelRequire("gElAV")));
function $6cb2aba8e68b4af0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShrinkVertical".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/shrink-vertical
 * Usage guidance:
 * Single purpose - Reserved for contracting or reducing the height of an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6cb2aba8e68b4af0$var$ShrinkVerticalIcon = (props)=>/*#__PURE__*/ $6cb2aba8e68b4af0$var$_react.default.createElement($6cb2aba8e68b4af0$var$_baseNew.default, Object.assign({
        name: "ShrinkVerticalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 9.75V16h-1.5V9.75zm-1.5-3.5V0h1.5v6.25z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="m8 10.81-2.97 2.97-1.06-1.06 3.5-3.5a.75.75 0 0 1 1.06 0l3.5 3.5-1.06 1.06zm-.53-4.03-3.5-3.5 1.06-1.06L8 5.19l2.97-2.97 1.06 1.06-3.5 3.5a.75.75 0 0 1-1.06 0" clip-rule="evenodd"/>`
    }, props));
$6cb2aba8e68b4af0$var$ShrinkVerticalIcon.displayName = 'ShrinkVerticalIcon';
var $6cb2aba8e68b4af0$var$_default = module.exports.default = $6cb2aba8e68b4af0$var$ShrinkVerticalIcon;

});

parcelRegister("cSGyR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6dbfccc48541e2997caa694cca1ab88a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $960b8af07f1ee9d5$var$_react = $960b8af07f1ee9d5$var$_interopRequireDefault((parcelRequire("cozmU")));

var $960b8af07f1ee9d5$var$_baseNew = $960b8af07f1ee9d5$var$_interopRequireDefault((parcelRequire("gElAV")));
function $960b8af07f1ee9d5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SmartLink".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/smart-link
 * Usage guidance:
 * Reserved for representing Smart links.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $960b8af07f1ee9d5$var$SmartLinkIcon = (props)=>/*#__PURE__*/ $960b8af07f1ee9d5$var$_react.default.createElement($960b8af07f1ee9d5$var$_baseNew.default, Object.assign({
        name: "SmartLinkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.117 1.547a3.933 3.933 0 0 1 4.663 6.234l-2.25 2.25-1.06-1.061 2.25-2.25a2.432 2.432 0 0 0-2.604-3.986q.132.361.134.766a2.25 2.25 0 1 1-1.133-1.953M8 2.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2.22 8.22l2.25-2.25 1.06 1.06-2.25 2.25a2.432 2.432 0 0 0 2.604 3.987 2.25 2.25 0 1 1 .998 1.187A3.933 3.933 0 0 1 2.22 8.22M8 11.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$960b8af07f1ee9d5$var$SmartLinkIcon.displayName = 'SmartLinkIcon';
var $960b8af07f1ee9d5$var$_default = module.exports.default = $960b8af07f1ee9d5$var$SmartLinkIcon;

});

parcelRegister("kvJb4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2820404f3c5c148a20d3c58a9e6675cf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eee9bf36c83ff020$var$_react = $eee9bf36c83ff020$var$_interopRequireDefault((parcelRequire("cozmU")));

var $eee9bf36c83ff020$var$_baseNew = $eee9bf36c83ff020$var$_interopRequireDefault((parcelRequire("gElAV")));
function $eee9bf36c83ff020$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SmartLinkCard".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/smart-link-card
 * Usage guidance:
 * Reserved for representing Smart link preview cards.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eee9bf36c83ff020$var$SmartLinkCardIcon = (props)=>/*#__PURE__*/ $eee9bf36c83ff020$var$_react.default.createElement($eee9bf36c83ff020$var$_baseNew.default, Object.assign({
        name: "SmartLinkCardIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 4.5a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h8v-7zm9.5 0v7H14a.5.5 0 0 0 .5-.5V5a.5.5 0 0 0-.5-.5zM0 5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm8.5 2.5H3V6h5.5zM6 10H3V8.5h3z" clip-rule="evenodd"/>`
    }, props));
$eee9bf36c83ff020$var$SmartLinkCardIcon.displayName = 'SmartLinkCardIcon';
var $eee9bf36c83ff020$var$_default = module.exports.default = $eee9bf36c83ff020$var$SmartLinkCardIcon;

});

parcelRegister("hWLxu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e2096ea41a9d5c70bf710640b56eec67>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d10cbabb82bc22f3$var$_react = $d10cbabb82bc22f3$var$_interopRequireDefault((parcelRequire("cozmU")));

var $d10cbabb82bc22f3$var$_baseNew = $d10cbabb82bc22f3$var$_interopRequireDefault((parcelRequire("gElAV")));
function $d10cbabb82bc22f3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SmartLinkInline".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/smart-link-inline
 * Usage guidance:
 * Reserved for representing inline Smart link lozenges.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d10cbabb82bc22f3$var$SmartLinkInlineIcon = (props)=>/*#__PURE__*/ $d10cbabb82bc22f3$var$_react.default.createElement($d10cbabb82bc22f3$var$_baseNew.default, Object.assign({
        name: "SmartLinkInlineIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 6.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2.5v-3zm4 0v3h8a.5.5 0 0 0 .5-.5V7a.5.5 0 0 0-.5-.5zM0 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$d10cbabb82bc22f3$var$SmartLinkInlineIcon.displayName = 'SmartLinkInlineIcon';
var $d10cbabb82bc22f3$var$_default = module.exports.default = $d10cbabb82bc22f3$var$SmartLinkInlineIcon;

});

parcelRegister("63qYG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::08358872d2fe09bcd83a85c0d7028fc5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4687f31816960ffa$var$_react = $4687f31816960ffa$var$_interopRequireDefault((parcelRequire("cozmU")));

var $4687f31816960ffa$var$_baseNew = $4687f31816960ffa$var$_interopRequireDefault((parcelRequire("gElAV")));
function $4687f31816960ffa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SortAscending".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/sort-ascending
 * Usage guidance:
 * Single purpose - Reserved for sorting data.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4687f31816960ffa$var$SortAscendingIcon = (props)=>/*#__PURE__*/ $4687f31816960ffa$var$_react.default.createElement($4687f31816960ffa$var$_baseNew.default, Object.assign({
        name: "SortAscendingIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 12.5H1V14h14zm-1.75-3.75V3.56l1.72 1.72 1.06-1.06-3-3a.75.75 0 0 0-1.06 0l-3 3 1.06 1.06 1.72-1.72v5.19zM8 7.25H1v1.5h7zM6 2H1v1.5h5z" clip-rule="evenodd"/>`
    }, props));
$4687f31816960ffa$var$SortAscendingIcon.displayName = 'SortAscendingIcon';
var $4687f31816960ffa$var$_default = module.exports.default = $4687f31816960ffa$var$SortAscendingIcon;

});

parcelRegister("fRmp0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fa83a5bc34ac8582b85e44007aafcb70>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b8bd2ee8462c467a$var$_react = $b8bd2ee8462c467a$var$_interopRequireDefault((parcelRequire("cozmU")));

var $b8bd2ee8462c467a$var$_baseNew = $b8bd2ee8462c467a$var$_interopRequireDefault((parcelRequire("gElAV")));
function $b8bd2ee8462c467a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StrokeWeightMedium".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/stroke-weight-medium
 * Usage guidance:
 * Reserved for representing medium border stroke widths.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b8bd2ee8462c467a$var$StrokeWeightMediumIcon = (props)=>/*#__PURE__*/ $b8bd2ee8462c467a$var$_react.default.createElement($b8bd2ee8462c467a$var$_baseNew.default, Object.assign({
        name: "StrokeWeightMediumIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.25 8a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0" clip-rule="evenodd"/>`
    }, props));
$b8bd2ee8462c467a$var$StrokeWeightMediumIcon.displayName = 'StrokeWeightMediumIcon';
var $b8bd2ee8462c467a$var$_default = module.exports.default = $b8bd2ee8462c467a$var$StrokeWeightMediumIcon;

});

parcelRegister("bWjzw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d11eff153c841858133d1bf073807447>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8b144b0ba272cbde$var$_react = $8b144b0ba272cbde$var$_interopRequireDefault((parcelRequire("cozmU")));

var $8b144b0ba272cbde$var$_baseNew = $8b144b0ba272cbde$var$_interopRequireDefault((parcelRequire("gElAV")));
function $8b144b0ba272cbde$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableCellClear".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/table-cell-clear
 * Usage guidance:
 * Reserved for clearing the contents of table cells.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8b144b0ba272cbde$var$TableCellClearIcon = (props)=>/*#__PURE__*/ $8b144b0ba272cbde$var$_react.default.createElement($8b144b0ba272cbde$var$_baseNew.default, Object.assign({
        name: "TableCellClearIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm6.94 4L5.22 6.28l1.06-1.06L8 6.94l1.72-1.72 1.06 1.06L9.06 8l1.72 1.72-1.06 1.06L8 9.06l-1.72 1.72-1.06-1.06z" clip-rule="evenodd"/>`
    }, props));
$8b144b0ba272cbde$var$TableCellClearIcon.displayName = 'TableCellClearIcon';
var $8b144b0ba272cbde$var$_default = module.exports.default = $8b144b0ba272cbde$var$TableCellClearIcon;

});

parcelRegister("5de7B", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53f35f736a7485fa368c194863f4dde7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3cb91ee2249fca7f$var$_react = $3cb91ee2249fca7f$var$_interopRequireDefault((parcelRequire("cozmU")));

var $3cb91ee2249fca7f$var$_baseNew = $3cb91ee2249fca7f$var$_interopRequireDefault((parcelRequire("gElAV")));
function $3cb91ee2249fca7f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableCellMerge".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/table-cell-merge
 * Usage guidance:
 * Reserved for merging table cells.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3cb91ee2249fca7f$var$TableCellMergeIcon = (props)=>/*#__PURE__*/ $3cb91ee2249fca7f$var$_react.default.createElement($3cb91ee2249fca7f$var$_baseNew.default, Object.assign({
        name: "TableCellMergeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h5V14H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h5v1.5zm12 0H9V2h5a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H9v-1.5h5a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5M5.19 8 3.47 6.28l1.06-1.06 2.25 2.25a.75.75 0 0 1 0 1.06l-2.25 2.25-1.06-1.06zm4.03-.53 2.25-2.25 1.06 1.06L10.81 8l1.72 1.72-1.06 1.06-2.25-2.25a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$3cb91ee2249fca7f$var$TableCellMergeIcon.displayName = 'TableCellMergeIcon';
var $3cb91ee2249fca7f$var$_default = module.exports.default = $3cb91ee2249fca7f$var$TableCellMergeIcon;

});

parcelRegister("haA5t", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bcb243daaba01c3631eac2781045d8f5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c7ff5cff87ecfd14$var$_react = $c7ff5cff87ecfd14$var$_interopRequireDefault((parcelRequire("cozmU")));

var $c7ff5cff87ecfd14$var$_baseNew = $c7ff5cff87ecfd14$var$_interopRequireDefault((parcelRequire("gElAV")));
function $c7ff5cff87ecfd14$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableColumnDelete".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/table-column-delete
 * Usage guidance:
 * Reserved for deleting a table column.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c7ff5cff87ecfd14$var$TableColumnDeleteIcon = (props)=>/*#__PURE__*/ $c7ff5cff87ecfd14$var$_react.default.createElement($c7ff5cff87ecfd14$var$_baseNew.default, Object.assign({
        name: "TableColumnDeleteIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h5.75c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-5.75C.615 15 0 14.384 0 13.625zm1.5.125v11h2v-11zm3.5 0v11h2v-11zm11 6.25h-6v-1.5h6z" clip-rule="evenodd"/>`
    }, props));
$c7ff5cff87ecfd14$var$TableColumnDeleteIcon.displayName = 'TableColumnDeleteIcon';
var $c7ff5cff87ecfd14$var$_default = module.exports.default = $c7ff5cff87ecfd14$var$TableColumnDeleteIcon;

});

parcelRegister("iRp8L", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::785478ea88664aaafe48fcdbc85c5e99>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dbb0ad9b4a7bd50f$var$_react = $dbb0ad9b4a7bd50f$var$_interopRequireDefault((parcelRequire("cozmU")));

var $dbb0ad9b4a7bd50f$var$_baseNew = $dbb0ad9b4a7bd50f$var$_interopRequireDefault((parcelRequire("gElAV")));
function $dbb0ad9b4a7bd50f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableColumnMoveRight".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/table-column-move-right
 * Usage guidance:
 * Reserved for moving a table column to the right of its current location.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dbb0ad9b4a7bd50f$var$TableColumnMoveRightIcon = (props)=>/*#__PURE__*/ $dbb0ad9b4a7bd50f$var$_react.default.createElement($dbb0ad9b4a7bd50f$var$_baseNew.default, Object.assign({
        name: "TableColumnMoveRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h5.75c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-5.75C.615 15 0 14.384 0 13.625zm1.5.125v11h2v-11zm3.5 0v11h2v-11zm7.78 1.97 3 3a.75.75 0 0 1 0 1.06l-3 3-1.06-1.06 1.72-1.72H10v-1.5h3.44l-1.72-1.72z" clip-rule="evenodd"/>`
    }, props));
$dbb0ad9b4a7bd50f$var$TableColumnMoveRightIcon.displayName = 'TableColumnMoveRightIcon';
var $dbb0ad9b4a7bd50f$var$_default = module.exports.default = $dbb0ad9b4a7bd50f$var$TableColumnMoveRightIcon;

});

parcelRegister("81DSz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::46b4079daca8f1cc509f2097261b00b8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5d7d59dfee5f3265$var$_react = $5d7d59dfee5f3265$var$_interopRequireDefault((parcelRequire("cozmU")));

var $5d7d59dfee5f3265$var$_baseNew = $5d7d59dfee5f3265$var$_interopRequireDefault((parcelRequire("gElAV")));
function $5d7d59dfee5f3265$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableRowDelete".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/table-row-delete
 * Usage guidance:
 * Reserved for deleting a table row.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5d7d59dfee5f3265$var$TableRowDeleteIcon = (props)=>/*#__PURE__*/ $5d7d59dfee5f3265$var$_react.default.createElement($5d7d59dfee5f3265$var$_baseNew.default, Object.assign({
        name: "TableRowDeleteIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.375 0C1.615 0 1 .616 1 1.375v5.75c0 .76.616 1.375 1.375 1.375h11.25c.76 0 1.375-.616 1.375-1.375v-5.75C15 .615 14.384 0 13.625 0zM2.5 1.5h11v2h-11zm0 3.5h11v2h-11zm8.5 7.25H5v1.5h6z" clip-rule="evenodd"/>`
    }, props));
$5d7d59dfee5f3265$var$TableRowDeleteIcon.displayName = 'TableRowDeleteIcon';
var $5d7d59dfee5f3265$var$_default = module.exports.default = $5d7d59dfee5f3265$var$TableRowDeleteIcon;

});

parcelRegister("1isWY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e7f791e0c797e0403bcc85f14d76758c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0f1dedd0030d7048$var$_react = $0f1dedd0030d7048$var$_interopRequireDefault((parcelRequire("cozmU")));

var $0f1dedd0030d7048$var$_baseNew = $0f1dedd0030d7048$var$_interopRequireDefault((parcelRequire("gElAV")));
function $0f1dedd0030d7048$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableRowMoveDown".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/table-row-move-down
 * Usage guidance:
 * Reserved for moving a table row below its current location.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0f1dedd0030d7048$var$TableRowMoveDownIcon = (props)=>/*#__PURE__*/ $0f1dedd0030d7048$var$_react.default.createElement($0f1dedd0030d7048$var$_baseNew.default, Object.assign({
        name: "TableRowMoveDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.375 0C1.615 0 1 .616 1 1.375v5.75c0 .76.616 1.375 1.375 1.375h11.25c.76 0 1.375-.616 1.375-1.375v-5.75C15 .615 14.384 0 13.625 0zM2.5 1.5h11v2h-11zm0 3.5h11v2h-11zm1.97 7.78 3 3a.75.75 0 0 0 1.06 0l3-3-1.06-1.06-1.72 1.72V10h-1.5v3.44l-1.72-1.72z" clip-rule="evenodd"/>`
    }, props));
$0f1dedd0030d7048$var$TableRowMoveDownIcon.displayName = 'TableRowMoveDownIcon';
var $0f1dedd0030d7048$var$_default = module.exports.default = $0f1dedd0030d7048$var$TableRowMoveDownIcon;

});

parcelRegister("UL6rM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0a51661b3cef1b2ac3d6354135b902aa>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0aa9c4bfd8e2087c$var$_react = $0aa9c4bfd8e2087c$var$_interopRequireDefault((parcelRequire("cozmU")));

var $0aa9c4bfd8e2087c$var$_baseNew = $0aa9c4bfd8e2087c$var$_interopRequireDefault((parcelRequire("gElAV")));
function $0aa9c4bfd8e2087c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Text".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/text
 * Usage guidance:
 * Single purpose - Reserved for representing text objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0aa9c4bfd8e2087c$var$TextIcon = (props)=>/*#__PURE__*/ $0aa9c4bfd8e2087c$var$_react.default.createElement($0aa9c4bfd8e2087c$var$_baseNew.default, Object.assign({
        name: "TextIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11 1v1.5H6.25V15h-1.5V2.5H0V1zm1 12V8h-2V6.5h2V4h1.5v2.5H16V8h-2.5v5a.5.5 0 0 0 .5.5h2V15h-2a2 2 0 0 1-2-2"/>`
    }, props));
$0aa9c4bfd8e2087c$var$TextIcon.displayName = 'TextIcon';
var $0aa9c4bfd8e2087c$var$_default = module.exports.default = $0aa9c4bfd8e2087c$var$TextIcon;

});

parcelRegister("96adu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::df859d5951d13a3bbd9d487ed8db4f14>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $69fc996673db952e$var$_react = $69fc996673db952e$var$_interopRequireDefault((parcelRequire("cozmU")));

var $69fc996673db952e$var$_baseNew = $69fc996673db952e$var$_interopRequireDefault((parcelRequire("gElAV")));
function $69fc996673db952e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextStrikethrough".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/text-strikethrough
 * Usage guidance:
 * Reserved for strikethrough text tool
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $69fc996673db952e$var$TextStrikethroughIcon = (props)=>/*#__PURE__*/ $69fc996673db952e$var$_react.default.createElement($69fc996673db952e$var$_baseNew.default, Object.assign({
        name: "TextStrikethroughIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M7.47 2.5a2.12 2.12 0 0 0-1.79 3.25H4.03a3.59 3.59 0 0 1 .5-3.25A3.62 3.62 0 0 1 7.47 1h.93a4.08 4.08 0 0 1 3.19 1.53l-1.17.94A2.58 2.58 0 0 0 8.4 2.5zm3.51 7.75h1.58A3.82 3.82 0 0 1 8.86 15h-.67a4.5 4.5 0 0 1-4.11-2.67l-.01-.02 1.37-.61.01.02a3 3 0 0 0 2.74 1.78h.67a2.32 2.32 0 0 0 2.12-3.25m4.02-3H1v1.5h14z"/>`
    }, props));
$69fc996673db952e$var$TextStrikethroughIcon.displayName = 'TextStrikethroughIcon';
var $69fc996673db952e$var$_default = module.exports.default = $69fc996673db952e$var$TextStrikethroughIcon;

});

parcelRegister("g4d3e", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0954b7f91a9901aae49863fc77bcb248>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bb2724bb9f4cc433$var$_react = $bb2724bb9f4cc433$var$_interopRequireDefault((parcelRequire("cozmU")));

var $bb2724bb9f4cc433$var$_baseNew = $bb2724bb9f4cc433$var$_interopRequireDefault((parcelRequire("gElAV")));
function $bb2724bb9f4cc433$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextUnderline".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/text-underline
 * Usage guidance:
 * Reserved for underlined text tool
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bb2724bb9f4cc433$var$TextUnderlineIcon = (props)=>/*#__PURE__*/ $bb2724bb9f4cc433$var$_react.default.createElement($bb2724bb9f4cc433$var$_baseNew.default, Object.assign({
        name: "TextUnderlineIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3.5 8V1H5v7a3 3 0 0 0 6 0V1h1.5v7a4.5 4.5 0 1 1-9 0M0 16v-1.5h16V16z" clip-rule="evenodd"/>`
    }, props));
$bb2724bb9f4cc433$var$TextUnderlineIcon.displayName = 'TextUnderlineIcon';
var $bb2724bb9f4cc433$var$_default = module.exports.default = $bb2724bb9f4cc433$var$TextUnderlineIcon;

});

parcelRegister("93fnf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6aebea72582f6eababb9832463b974a4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $697051d40f000e89$var$_react = $697051d40f000e89$var$_interopRequireDefault((parcelRequire("cozmU")));

var $697051d40f000e89$var$_baseNew = $697051d40f000e89$var$_interopRequireDefault((parcelRequire("gElAV")));
function $697051d40f000e89$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ThumbsDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/thumbs-down
 * Usage guidance:
 * Multi purpose - Known uses: voting, feedback in AI.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $697051d40f000e89$var$ThumbsDownIcon = (props)=>/*#__PURE__*/ $697051d40f000e89$var$_react.default.createElement($697051d40f000e89$var$_baseNew.default, Object.assign({
        name: "ThumbsDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.292 13.406a.5.5 0 0 0 .77-.15l2.438-4.69V2.5H4.128c-.492 0-.927.32-1.073.79L1.726 7.54A1.125 1.125 0 0 0 2.8 9h3.45a.75.75 0 0 1 .75.75v3.175a.5.5 0 0 0 .174.38zM12 2.5V8h2a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm-.295 7-2.313 4.45a2 2 0 0 1-3.076.596l-.118-.101a2 2 0 0 1-.698-1.519V10.5H2.8A2.625 2.625 0 0 1 .295 7.092l1.328-4.25A2.625 2.625 0 0 1 4.128 1H14a2 2 0 0 1 2 2v4.5a2 2 0 0 1-2 2z" clip-rule="evenodd"/>`
    }, props));
$697051d40f000e89$var$ThumbsDownIcon.displayName = 'ThumbsDownIcon';
var $697051d40f000e89$var$_default = module.exports.default = $697051d40f000e89$var$ThumbsDownIcon;

});

parcelRegister("iJUbs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9df65e008c973540f95c4b52fbcf6e29>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $da4802e01f5dda8e$var$_react = $da4802e01f5dda8e$var$_interopRequireDefault((parcelRequire("cozmU")));

var $da4802e01f5dda8e$var$_baseNew = $da4802e01f5dda8e$var$_interopRequireDefault((parcelRequire("gElAV")));
function $da4802e01f5dda8e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Translate".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/translate
 * Usage guidance:
 * Reserved for representing language translations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $da4802e01f5dda8e$var$TranslateIcon = (props)=>/*#__PURE__*/ $da4802e01f5dda8e$var$_react.default.createElement($da4802e01f5dda8e$var$_baseNew.default, Object.assign({
        name: "TranslateIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.395 4.5H0V3h4V1h1.5v2h4v1.5H6.911c-.252 1.771-.704 3.325-1.338 4.685.471.522.973.973 1.479 1.323l-.854 1.234a10 10 0 0 1-1.377-1.17 12.2 12.2 0 0 1-2.991 3.275l-.91-1.194a10.7 10.7 0 0 0 2.867-3.276 12.5 12.5 0 0 1-1.74-3.114l1.405-.526c.265.706.633 1.418 1.073 2.087.385-.982.68-2.085.87-3.324m5.17 1.945A.75.75 0 0 1 11.25 6h.5a.75.75 0 0 1 .685.445l3.5 7.875a.75.75 0 0 1 .065.305V15h-1.5v-.216L13.707 13H9.293L8.5 14.784V15H7v-.375a.75.75 0 0 1 .065-.305zM9.96 11.5h3.08L11.5 8.034z" clip-rule="evenodd"/>`
    }, props));
$da4802e01f5dda8e$var$TranslateIcon.displayName = 'TranslateIcon';
var $da4802e01f5dda8e$var$_default = module.exports.default = $da4802e01f5dda8e$var$TranslateIcon;

});

parcelRegister("1pTZX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d47bc9d05f833e571cfad83015f1dfb8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $10839054783f86c0$var$_react = $10839054783f86c0$var$_interopRequireDefault((parcelRequire("cozmU")));

var $10839054783f86c0$var$_baseNew = $10839054783f86c0$var$_interopRequireDefault((parcelRequire("gElAV")));
function $10839054783f86c0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoStopOverlay".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/video-stop-overlay
 * Usage guidance:
 * Reserved for stopping video content. Use on dark or translucent backgrounds.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $10839054783f86c0$var$VideoStopOverlayIcon = (props)=>/*#__PURE__*/ $10839054783f86c0$var$_react.default.createElement($10839054783f86c0$var$_baseNew.default, Object.assign({
        name: "VideoStopOverlayIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/><path fill="currentcolor" d="M2.5 3a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5z"/>`
    }, props));
$10839054783f86c0$var$VideoStopOverlayIcon.displayName = 'VideoStopOverlayIcon';
var $10839054783f86c0$var$_default = module.exports.default = $10839054783f86c0$var$VideoStopOverlayIcon;

});

parcelRegister("lSQgn", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $9NPFC = parcelRequire("9NPFC");

const $2ca494cd0880e4b3$var$iconColorMap = {
    blue: "_1UtDYzXb4z",
    blueBold: "_1UtDYz8ujp",
    gray: "_1UtDYz4YkS",
    grayBold: "_1UtDYz6BYM",
    green: "_1UtDYzYn9z",
    greenBold: "_1UtDYz8ujp",
    lime: "_1UtDYzqM33",
    limeBold: "_1UtDYz8ujp",
    magenta: "_1UtDYzOPmJ",
    magentaBold: "_1UtDYz8ujp",
    orange: "_1UtDYzR8hD",
    orangeBold: "_1UtDYz8ujp",
    purple: "_1UtDYzJhIs",
    purpleBold: "_1UtDYz8ujp",
    red: "_1UtDYztn31",
    redBold: "_1UtDYz8ujp",
    teal: "_1UtDYzdT8X",
    tealBold: "_1UtDYz8ujp",
    yellow: "_1UtDYzx3zE",
    yellowBold: "_1UtDYz8ujp"
};
const $2ca494cd0880e4b3$var$iconWrapperStyles = {
    root: "_26BoRwdnbC"
}; // Background color mapping for Tile component
const $2ca494cd0880e4b3$var$backgroundColorMap = {
    blue: undefined,
    blueBold: 'color.background.accent.blue.subtle',
    gray: undefined,
    grayBold: 'color.background.neutral.bold',
    green: undefined,
    greenBold: 'color.background.accent.green.subtle',
    lime: undefined,
    limeBold: 'color.background.accent.lime.subtle',
    magenta: undefined,
    magentaBold: 'color.background.accent.magenta.subtle',
    orange: undefined,
    orangeBold: 'color.background.accent.orange.subtle',
    purple: undefined,
    purpleBold: 'color.background.accent.purple.subtle',
    red: undefined,
    redBold: 'color.background.accent.red.subtle',
    teal: undefined,
    tealBold: 'color.background.accent.teal.subtle',
    yellow: undefined,
    yellowBold: 'color.background.accent.yellow.subtle'
};
/**
 * __IconTile__
 *
 * An icon with background color and size properties determined by Tile.
 */ const $2ca494cd0880e4b3$var$IconTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function IconTile(props) {
    const $ = (0, $bDgLe.c)(13);
    const { icon: Icon, label: label, appearance: appearance, size: t0, testId: testId } = props;
    const size = t0 === undefined ? "medium" : t0;
    const ExpandedIcon = Icon;
    const t1 = $2ca494cd0880e4b3$var$backgroundColorMap[appearance];
    const t2 = $2ca494cd0880e4b3$var$iconColorMap[appearance];
    let t3;
    if ($[0] !== t2) {
        t3 = (0, $hekY6.default)([
            t2,
            $2ca494cd0880e4b3$var$iconWrapperStyles.root
        ]);
        $[0] = t2;
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] !== ExpandedIcon) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)(ExpandedIcon, {
            color: "currentColor",
            label: "",
            shouldScale: true
        });
        $[2] = ExpandedIcon;
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== t3 || $[5] !== t4) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            className: t3,
            children: t4
        });
        $[4] = t3;
        $[5] = t4;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== label || $[8] !== size || $[9] !== t1 || $[10] !== t5 || $[11] !== testId) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9NPFC.default), {
            size: size,
            backgroundColor: t1,
            label: label,
            testId: testId,
            children: t5
        });
        $[7] = label;
        $[8] = size;
        $[9] = t1;
        $[10] = t5;
        $[11] = testId;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
} : function IconTile(props) {
    const { icon: Icon, label: label, appearance: appearance, size: size = 'medium', testId: testId } = props;
    const ExpandedIcon = Icon;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9NPFC.default), {
        size: size,
        backgroundColor: $2ca494cd0880e4b3$var$backgroundColorMap[appearance],
        label: label,
        testId: testId,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            className: (0, $hekY6.default)([
                $2ca494cd0880e4b3$var$iconColorMap[appearance],
                $2ca494cd0880e4b3$var$iconWrapperStyles.root
            ]),
            children: /*#__PURE__*/ (0, $8aG6j.jsx)(ExpandedIcon, {
                color: "currentColor",
                label: "",
                shouldScale: true
            })
        })
    });
};
var $2ca494cd0880e4b3$export$2e2bcd8739ae039 = $2ca494cd0880e4b3$var$IconTile;
module.exports["default"] = $2ca494cd0880e4b3$export$2e2bcd8739ae039;

});

parcelRegister("4GyjL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2ced299804fb01385fefefbab429e216>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3695b476e744c197$var$_react = $3695b476e744c197$var$_interopRequireDefault((parcelRequire("cozmU")));

var $3695b476e744c197$var$_baseNew = $3695b476e744c197$var$_interopRequireDefault((parcelRequire("gElAV")));
function $3695b476e744c197$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuotationBlock".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/quotation-block
 * Usage guidance:
 * Preferred for representing block quotes and quote text style in Confluence
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3695b476e744c197$var$QuotationBlockIcon = (props)=>/*#__PURE__*/ $3695b476e744c197$var$_react.default.createElement($3695b476e744c197$var$_baseNew.default, Object.assign({
        name: "QuotationBlockIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M9.5 9a2 2 0 0 1 2 2v2.94c0 .59-.48 1.06-1.06 1.06H9.06A1.06 1.06 0 0 1 8 13.94v-1.38c0-.59.48-1.06 1.06-1.06H10V11a.5.5 0 0 0-.5-.5H9V9zM6.94 1C7.52 1 8 1.48 8 2.06v1.37c0 .59-.48 1.07-1.06 1.07H6V5a.5.5 0 0 0 .5.5H7V7h-.5a2 2 0 0 1-2-2V2.06C4.5 1.48 4.98 1 5.56 1zM14 9a2 2 0 0 1 2 2v2.94c0 .59-.48 1.06-1.06 1.06h-1.38a1.06 1.06 0 0 1-1.06-1.06v-1.38c0-.59.48-1.06 1.06-1.06h.94V11a.5.5 0 0 0-.5-.5h-.5V9zM2.44 1c.58 0 1.06.48 1.06 1.06v1.37c0 .59-.48 1.06-1.06 1.06H1.5V5a.5.5 0 0 0 .5.5h.5V7H2a2 2 0 0 1-2-2V2.06C0 1.48.48 1 1.06 1z"/>`
    }, props));
$3695b476e744c197$var$QuotationBlockIcon.displayName = 'QuotationBlockIcon';
var $3695b476e744c197$var$_default = module.exports.default = $3695b476e744c197$var$QuotationBlockIcon;

});


$parcel$global.rlb("ffEVr")
//# sourceMappingURL=vendors~editor_icon.ece3054d.js.map
